/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: any; output: any; }
  AWSDateTime: { input: any; output: any; }
  AWSEmail: { input: any; output: any; }
  AWSIPAddress: { input: any; output: any; }
  AWSJSON: { input: any; output: any; }
  AWSPhone: { input: any; output: any; }
  AWSTime: { input: any; output: any; }
  AWSTimestamp: { input: any; output: any; }
  AWSURL: { input: any; output: any; }
};

export type AccessAssignment = {
  readonly access: Scalars['Int']['input'];
  readonly agentId?: InputMaybe<Scalars['String']['input']>;
  readonly appId?: InputMaybe<Scalars['ID']['input']>;
  readonly excludePages?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly includePages?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly pageContext?: InputMaybe<AgentPageContextInput>;
  readonly scenarioId?: InputMaybe<Scalars['ID']['input']>;
  readonly tenantId?: InputMaybe<Scalars['ID']['input']>;
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
  readonly zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminAgentKnowledgeBaseFileListInput = {
  readonly dataSourceId?: InputMaybe<Scalars['String']['input']>;
  readonly knowledgeBaseId?: InputMaybe<Scalars['String']['input']>;
  readonly target?: InputMaybe<AdminAgentKnowledgeBaseManagementTargetInput>;
};

export type AdminAgentKnowledgeBaseFileTargetInput = {
  readonly dataSourceId: Scalars['String']['input'];
  readonly key: Scalars['String']['input'];
  readonly knowledgeBaseId: Scalars['String']['input'];
};

export type AdminAgentKnowledgeBaseManagementTargetInput = {
  readonly modelId?: InputMaybe<Scalars['ID']['input']>;
  readonly recordId?: InputMaybe<Scalars['ID']['input']>;
  readonly tenantId: Scalars['ID']['input'];
  readonly zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminAgentKnowledgeBaseUploadInput = {
  readonly dataSourceId?: InputMaybe<Scalars['String']['input']>;
  readonly knowledgeBaseId?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly sizeBytes: Scalars['Int']['input'];
  readonly target?: InputMaybe<AdminAgentKnowledgeBaseManagementTargetInput>;
};

export type AgentChatConversationInput = {
  readonly agentId: Scalars['String']['input'];
  readonly id: Scalars['ID']['input'];
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly sharedWith?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type AgentChatMessageConversationContextInput = {
  readonly agentId: Scalars['String']['input'];
  readonly conversationId: Scalars['ID']['input'];
  readonly workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type AgentChatMessageInfoInput = {
  readonly createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly payload?: InputMaybe<Scalars['AWSJSON']['input']>;
  readonly type: Scalars['String']['input'];
};

export type AgentChatMessageInput = {
  readonly id: Scalars['ID']['input'];
  readonly info?: InputMaybe<ReadonlyArray<AgentChatMessageInfoInput>>;
};

export type AgentChatWorkspaceInput = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly name: Scalars['String']['input'];
  readonly sharedWith?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type AgentConfigurationContextInput = {
  readonly dmsResources?: InputMaybe<Scalars['AWSJSON']['input']>;
  readonly instructions?: InputMaybe<Scalars['String']['input']>;
  readonly knowledgeBaseFiles?: InputMaybe<ReadonlyArray<AgentKnowledgeBaseFileInput>>;
};

export type AgentConfigurationInput = {
  readonly agentId: Scalars['String']['input'];
  readonly context?: InputMaybe<AgentConfigurationContextInput>;
  readonly conversationId?: InputMaybe<Scalars['String']['input']>;
};

export type AgentKnowledgeBaseFileInput = {
  readonly knowledgeBaseId: Scalars['String']['input'];
  readonly s3Uri: Scalars['String']['input'];
};

export type AgentKnowledgeBaseRetrievalInput = {
  readonly records?: InputMaybe<ReadonlyArray<AgentKnowledgeBaseRetrievalRecordInput>>;
};

export type AgentKnowledgeBaseRetrievalRecordInput = {
  readonly modelId: Scalars['String']['input'];
  readonly recordId: Scalars['String']['input'];
};

export enum AgentMessageRole {
  Agent = 'AGENT',
  User = 'USER'
}

export enum AgentMessageStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type AgentPageContextInput = {
  readonly isForNonPrebuiltPages?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pageAliases?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

export enum Anomaly {
  IncorrectDoorNumber = 'INCORRECT_DOOR_NUMBER',
  IncorrectFloorPlan = 'INCORRECT_FLOOR_PLAN',
  RoomDoesNotExists = 'ROOM_DOES_NOT_EXISTS'
}

export type AppInput = {
  readonly alias: Scalars['String']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly icon: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
  readonly sessionVariables?: InputMaybe<ReadonlyArray<VariableInput>>;
  readonly supportsScenarios?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppPageDisplayInput = {
  readonly isMain: Scalars['Boolean']['input'];
  readonly position: Scalars['Int']['input'];
};

export type AppPageFilterInput = {
  readonly isMain?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppPageInput = {
  readonly alias: Scalars['ID']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly display?: InputMaybe<AppPageDisplayInput>;
  readonly name: Scalars['String']['input'];
  readonly page: FlexibleIdentifierInput;
  readonly variables?: InputMaybe<ReadonlyArray<VariableValueInput>>;
};

export type AppPageUpdates = {
  readonly alias: Scalars['ID']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly display?: InputMaybe<AppPageDisplayInput>;
  readonly name: Scalars['String']['input'];
  readonly page: FlexibleIdentifierInput;
  readonly variables?: InputMaybe<ReadonlyArray<VariableValueInput>>;
};

export type AppUpdates = {
  readonly alias?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly icon?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly sessionVariables?: InputMaybe<ReadonlyArray<VariableInput>>;
};

export type Archive = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly employees: ReadonlyArray<Scalars['ID']['input']>;
  readonly instructions?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
};

export enum ChangeEventType {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

export type ClusterInput = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly organizationId: Scalars['ID']['input'];
};

export type ClusterUpdateInput = {
  readonly comment?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type DataDeletion = {
  readonly ids: ReadonlyArray<Scalars['ID']['input']>;
  readonly modelId: Scalars['ID']['input'];
};

export type DataInsertion = {
  readonly inputs: DataInsertionInputs;
  readonly modelId: Scalars['ID']['input'];
  readonly onConflict?: InputMaybe<DataInsertionOnConflict>;
};

export type DataInsertionInputs = {
  readonly records: ReadonlyArray<Scalars['AWSJSON']['input']>;
};

export enum DataInsertionOnConflict {
  Error = 'ERROR',
  Overwrite = 'OVERWRITE',
  Skip = 'SKIP'
}

export type DataUpdate = {
  readonly modelId: Scalars['ID']['input'];
  readonly records: ReadonlyArray<Scalars['AWSJSON']['input']>;
};

export type DateRangeInput = {
  readonly end?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly start?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type DmsAttributeInput = {
  readonly constraints?: InputMaybe<ValueConstraintsInput>;
  readonly context: Scalars['String']['input'];
  readonly default?: InputMaybe<Scalars['AWSJSON']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name: Scalars['String']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly scoring?: InputMaybe<DmsAttributeScoringInput>;
  readonly termsIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly type: DmsValueTypeForAttributeInput;
};

export type DmsAttributeScoreValueInput = {
  readonly key: Scalars['String']['input'];
  readonly value: Scalars['Int']['input'];
};

export type DmsAttributeScoringInput = {
  readonly default?: InputMaybe<Scalars['Int']['input']>;
  readonly lookup?: InputMaybe<ReadonlyArray<DmsAttributeScoreValueInput>>;
};

export type DmsDimensionInput = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly termsIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type DmsDimensionUpdates = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly termsIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type DmsEntityInput = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly dimension: Scalars['ID']['input'];
  readonly level: Scalars['Int']['input'];
  readonly name: Scalars['String']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly termsIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type DmsEntityUpdates = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly level?: InputMaybe<Scalars['Int']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly termsIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type DmsEnumInput = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly termsIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type DmsEnumUpdates = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly termsIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type DmsEnumValueTypeInput = {
  readonly enumId: Scalars['ID']['input'];
  readonly isMultiselect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DmsFilesValueTypeInput = {
  readonly isFile?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DmsInlineEnumValueTypeInput = {
  readonly entries?: InputMaybe<ReadonlyArray<EnumValueTypeEntryInput>>;
  readonly isMultiselect?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DmsModelType {
  Attribute = 'ATTRIBUTE',
  Dimension = 'DIMENSION',
  Entity = 'ENTITY',
  Enum = 'ENUM',
  Purpose = 'PURPOSE',
  Snapshot = 'SNAPSHOT',
  Structure = 'STRUCTURE'
}

export type DmsMultiReferenceValueTypeInput = {
  readonly dimensionId: Scalars['ID']['input'];
};

export type DmsPurposeInput = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly termsIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type DmsPurposeUpdates = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly termsIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type DmsReferenceValueTypeInput = {
  readonly dimensionId: Scalars['ID']['input'];
};

export type DmsStructureInput = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly termsIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type DmsStructureUpdates = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly termsIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type DmsStructureValueTypeInput = {
  readonly structureId: Scalars['ID']['input'];
};

export type DmsTermInput = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
};

export type DmsTermUpdates = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type DmsValueTypeForAttributeInput = {
  readonly enum?: InputMaybe<DmsEnumValueTypeInput>;
  readonly files?: InputMaybe<DmsFilesValueTypeInput>;
  readonly intrinsic?: InputMaybe<IntrinsicValueType>;
  readonly reference?: InputMaybe<DmsReferenceValueTypeInput>;
  readonly structure?: InputMaybe<DmsStructureValueTypeInput>;
};

export type DmsValueTypeInput = {
  readonly enum?: InputMaybe<DmsEnumValueTypeInput>;
  readonly files?: InputMaybe<DmsFilesValueTypeInput>;
  readonly inlineEnum?: InputMaybe<DmsInlineEnumValueTypeInput>;
  readonly intrinsic?: InputMaybe<IntrinsicValueType>;
  readonly multiReference?: InputMaybe<DmsMultiReferenceValueTypeInput>;
  readonly reference?: InputMaybe<DmsReferenceValueTypeInput>;
  readonly structure?: InputMaybe<DmsStructureValueTypeInput>;
};

export type EnumValueTypeEntryInput = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type FaFunctionCategorizationInput = {
  readonly categoryId: Scalars['ID']['input'];
  readonly subcategoryId?: InputMaybe<Scalars['ID']['input']>;
};

export type FaFunctionCategoryFilters = {
  readonly type?: InputMaybe<FaFunctionType>;
};

export enum FaFunctionType {
  Administration = 'ADMINISTRATION',
  Direct = 'DIRECT',
  Facilities = 'FACILITIES'
}

export type FileInput = {
  readonly appId?: InputMaybe<Scalars['ID']['input']>;
  readonly extension?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  readonly purpose?: InputMaybe<FilePurpose>;
  readonly qualifier?: InputMaybe<Scalars['String']['input']>;
  readonly scenarioId?: InputMaybe<Scalars['ID']['input']>;
};

export enum FilePurpose {
  DmsUpload = 'DMS_UPLOAD',
  FileManagement = 'FILE_MANAGEMENT'
}

export type FlexibleIdentifierInput = {
  readonly alias?: InputMaybe<Scalars['ID']['input']>;
  readonly id?: InputMaybe<Scalars['ID']['input']>;
};

export type GeneralLedgerFilterComparisonInput = {
  readonly attributeId: Scalars['ID']['input'];
  readonly operator: GeneralLedgerFilterComparisonOperator;
  readonly value: Scalars['AWSJSON']['input'];
};

export enum GeneralLedgerFilterComparisonOperator {
  Contains = 'CONTAINS',
  Ends = 'ENDS',
  Eq = 'EQ',
  Greater = 'GREATER',
  GreaterEq = 'GREATER_EQ',
  Less = 'LESS',
  LessEq = 'LESS_EQ',
  Neq = 'NEQ',
  Starts = 'STARTS'
}

export type GeneralLedgerFilterInput = {
  readonly comparison?: InputMaybe<GeneralLedgerFilterComparisonInput>;
  readonly selection?: InputMaybe<GeneralLedgerFilterSelectionInput>;
  readonly statement?: InputMaybe<GeneralLedgerFilterStatementInput>;
};

export type GeneralLedgerFilterSelectionInput = {
  readonly attributeId: Scalars['ID']['input'];
  readonly values: ReadonlyArray<Scalars['String']['input']>;
};

export enum GeneralLedgerFilterStatementConnector {
  And = 'AND',
  Or = 'OR'
}

export type GeneralLedgerFilterStatementInput = {
  readonly connector: GeneralLedgerFilterStatementConnector;
  readonly filters: ReadonlyArray<GeneralLedgerFilterInput>;
};

export type GeneralLedgerSortInput = {
  readonly ascending?: InputMaybe<Scalars['Boolean']['input']>;
  readonly attributeId: Scalars['ID']['input'];
};

export enum GrantSourceKind {
  Policy = 'POLICY',
  Role = 'ROLE'
}

export type IntgApiQueryParameterInput = {
  readonly name: Scalars['String']['input'];
  readonly value: Scalars['String']['input'];
};

export enum IntgApiResponseType {
  Array = 'ARRAY',
  Object = 'OBJECT'
}

export type IntgApiSourceInput = {
  readonly pagination?: InputMaybe<Scalars['AWSJSON']['input']>;
  readonly path: Scalars['String']['input'];
  readonly query?: InputMaybe<ReadonlyArray<IntgApiQueryParameterInput>>;
  readonly recordsPath?: InputMaybe<Scalars['String']['input']>;
  readonly responseType: IntgApiResponseType;
};

export type IntgConnectorDefinitionImportInput = {
  readonly api: IntgApiSourceInput;
  readonly mapping: IntgDmsMappingInput;
};

export type IntgConnectorDefinitionInput = {
  readonly imports: ReadonlyArray<IntgConnectorDefinitionImportInput>;
  readonly name: Scalars['String']['input'];
};

export type IntgConnectorDefinitionUpdates = {
  readonly imports?: InputMaybe<ReadonlyArray<IntgConnectorDefinitionImportInput>>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type IntgConnectorInput = {
  readonly baseUrl: Scalars['String']['input'];
  readonly definitionId: Scalars['ID']['input'];
  readonly name: Scalars['String']['input'];
};

export type IntgConnectorUpdates = {
  readonly baseUrl?: InputMaybe<Scalars['String']['input']>;
  readonly definitionId?: InputMaybe<Scalars['ID']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type IntgDmsMappingFieldInput = {
  readonly reference?: InputMaybe<IntgDmsMappingFieldReferenceInput>;
  readonly source: Scalars['String']['input'];
  readonly target: Scalars['ID']['input'];
};

export type IntgDmsMappingFieldReferenceInput = {
  readonly entityId: Scalars['ID']['input'];
};

export type IntgDmsMappingInput = {
  readonly fields: ReadonlyArray<IntgDmsMappingFieldInput>;
  readonly modelId: Scalars['ID']['input'];
};

export enum IntrinsicValueType {
  Boolean = 'BOOLEAN',
  Currency = 'CURRENCY',
  Date = 'DATE',
  DateMultirange = 'DATE_MULTIRANGE',
  DateRange = 'DATE_RANGE',
  Decimal = 'DECIMAL',
  Int = 'INT',
  List = 'LIST',
  Object = 'OBJECT',
  Percent = 'PERCENT',
  Text = 'TEXT',
  Url = 'URL'
}

export enum MemberCoverage {
  Ancestor = 'ANCESTOR',
  Partial = 'PARTIAL',
  Self = 'SELF'
}

export type MosaicActionInput = {
  readonly alias: Scalars['String']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly query: Scalars['AWSJSON']['input'];
};

export type MosaicActionUpdates = {
  readonly alias?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly query?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export enum MosaicNoticeType {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type MosaicPageForDevInput = {
  readonly alias: Scalars['ID']['input'];
  readonly content?: InputMaybe<Scalars['AWSJSON']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly query?: InputMaybe<Scalars['AWSJSON']['input']>;
  readonly variables?: InputMaybe<ReadonlyArray<VariableInput>>;
};

export type MosaicPageForDevUpdates = {
  readonly alias?: InputMaybe<Scalars['ID']['input']>;
  readonly content?: InputMaybe<Scalars['AWSJSON']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly query?: InputMaybe<Scalars['AWSJSON']['input']>;
  readonly variables?: InputMaybe<ReadonlyArray<VariableInput>>;
};

export enum MosaicPageSegmentNavigator {
  Scrolling = 'SCROLLING',
  Tabs = 'TABS'
}

export type MosaicWidgetInput = {
  readonly alias: Scalars['String']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly query: Scalars['AWSJSON']['input'];
  readonly variables?: InputMaybe<ReadonlyArray<VariableInput>>;
};

export type MosaicWidgetUpdates = {
  readonly alias?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly query?: InputMaybe<Scalars['AWSJSON']['input']>;
  readonly variables?: InputMaybe<ReadonlyArray<VariableInput>>;
};

export type NoAppScenarioContextInput = {
  readonly scenarioId: Scalars['ID']['input'];
  readonly tenantId: Scalars['ID']['input'];
};

export enum NotificationAction {
  Dismiss = 'DISMISS',
  Read = 'READ',
  Unread = 'UNREAD'
}

export type NotificationInput = {
  readonly description: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
};

export enum OccupantPayrollAssignment {
  Full = 'FULL',
  None = 'NONE',
  Partial = 'PARTIAL'
}

export enum OrgJointUseCalculationMode {
  Inherit = 'INHERIT',
  Manual = 'MANUAL',
  Salary = 'SALARY'
}

export type OrganizationAssignmentInput = {
  readonly organizationId: Scalars['ID']['input'];
};

export type OrganizationJointUseUpdate = {
  readonly calculationMode: OrgJointUseCalculationMode;
  readonly manualFunctionalizations?: InputMaybe<ReadonlyArray<SpaceFunctionalizationInput>>;
};

export type OrganizationsFilterInput = {
  readonly includeInaccessible?: InputMaybe<Scalars['Boolean']['input']>;
  readonly jointUseCalcMode?: InputMaybe<OrgJointUseCalculationMode>;
  readonly parentIds?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

export type PeriodInput = {
  readonly endDate?: InputMaybe<Scalars['AWSDate']['input']>;
  readonly startDate?: InputMaybe<Scalars['AWSDate']['input']>;
};

export type PolicyConditionInput = {
  readonly key: Scalars['String']['input'];
  readonly operator: Scalars['String']['input'];
  readonly values: ReadonlyArray<Scalars['String']['input']>;
};

export type PolicyContextInput = {
  readonly appId?: InputMaybe<Scalars['ID']['input']>;
  readonly scenarioId?: InputMaybe<Scalars['ID']['input']>;
  readonly tenantId: Scalars['ID']['input'];
  readonly zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export enum PolicyDecisionReason {
  Allow = 'ALLOW',
  ExplicitDeny = 'EXPLICIT_DENY',
  ImplicitDeny = 'IMPLICIT_DENY'
}

export enum PolicyEffect {
  Allow = 'ALLOW',
  Deny = 'DENY'
}

export enum PolicyResourceType {
  Agent = 'AGENT',
  App = 'APP',
  Page = 'PAGE',
  Scenario = 'SCENARIO',
  Tenant = 'TENANT',
  User = 'USER',
  Zone = 'ZONE'
}

export type PolicyStatementInput = {
  readonly actions: ReadonlyArray<Scalars['String']['input']>;
  readonly conditions?: InputMaybe<ReadonlyArray<PolicyConditionInput>>;
  readonly effect: PolicyEffect;
  readonly resources: ReadonlyArray<Scalars['String']['input']>;
  readonly sid?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessActivityExecutionPublishInput = {
  readonly detail?: InputMaybe<Scalars['String']['input']>;
  readonly item?: InputMaybe<ProcessItemRefPublishInput>;
  readonly status?: InputMaybe<ProcessExecutionStatus>;
  readonly timeframe?: InputMaybe<DateRangeInput>;
  readonly type?: InputMaybe<ProcessActivityType>;
};

export enum ProcessActivityType {
  ExtractingDmsRecordsFromExcelWorksheet = 'EXTRACTING_DMS_RECORDS_FROM_EXCEL_WORKSHEET',
  GenerateFileContent = 'GENERATE_FILE_CONTENT',
  ParsingExcelWorkbook = 'PARSING_EXCEL_WORKBOOK',
  PuttingDmsRecords = 'PUTTING_DMS_RECORDS',
  RateCalcAllocations = 'RATE_CALC_ALLOCATIONS',
  RateCalcPools = 'RATE_CALC_POOLS',
  RateGenReportContent = 'RATE_GEN_REPORT_CONTENT',
  RateRefreshGlRecords = 'RATE_REFRESH_GL_RECORDS',
  RateWriteGlRecordsToDms = 'RATE_WRITE_GL_RECORDS_TO_DMS',
  RenderFile = 'RENDER_FILE',
  RetrievingS3Object = 'RETRIEVING_S3_OBJECT',
  ScenarioAddToList = 'SCENARIO_ADD_TO_LIST',
  ScenarioAssigningUser = 'SCENARIO_ASSIGNING_USER',
  ScenarioImporting = 'SCENARIO_IMPORTING',
  ScenarioSettingUp = 'SCENARIO_SETTING_UP',
  StoreFile = 'STORE_FILE'
}

export type ProcessEssentialsDismissInput = {
  readonly appId?: InputMaybe<Scalars['ID']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly scenarioId?: InputMaybe<Scalars['ID']['input']>;
  readonly tenantId: Scalars['ID']['input'];
  readonly zoneId: Scalars['ID']['input'];
};

export type ProcessEssentialsPublishInput = {
  readonly activities?: InputMaybe<ReadonlyArray<InputMaybe<ProcessActivityExecutionPublishInput>>>;
  readonly appId?: InputMaybe<Scalars['ID']['input']>;
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly items?: InputMaybe<ReadonlyArray<InputMaybe<ProcessItemPublishInput>>>;
  readonly scenarioId?: InputMaybe<Scalars['ID']['input']>;
  readonly templateId?: InputMaybe<Scalars['ID']['input']>;
  readonly tenantId?: InputMaybe<Scalars['ID']['input']>;
  readonly zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export enum ProcessExecutionStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Stopping = 'STOPPING',
  Succeeded = 'SUCCEEDED'
}

export type ProcessItemPublishInput = {
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly type?: InputMaybe<ProcessItemType>;
};

export type ProcessItemRefPublishInput = {
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly type?: InputMaybe<ProcessItemType>;
};

export enum ProcessItemType {
  Allocation = 'ALLOCATION',
  Entity = 'ENTITY',
  Importer = 'IMPORTER',
  Pool = 'POOL',
  Report = 'REPORT',
  Unknown = 'UNKNOWN'
}

export type RateMappingEntryInput = {
  readonly categorization?: InputMaybe<FaFunctionCategorizationInput>;
  readonly exclusionLabel?: InputMaybe<Scalars['String']['input']>;
  readonly percent: Scalars['Float']['input'];
};

export type RateMappingInput = {
  readonly adjustmentLabel?: InputMaybe<Scalars['String']['input']>;
  readonly entries: ReadonlyArray<RateMappingEntryInput>;
};

export type RateReportLabelBatchUpdateEntry = {
  readonly id: Scalars['ID']['input'];
  readonly updates: RateReportLabelUpdates;
};

export type RateReportLabelFilters = {
  readonly faFunctionCategorization?: InputMaybe<FaFunctionCategorizationInput>;
  readonly isActive?: InputMaybe<Scalars['Boolean']['input']>;
  readonly purposes?: InputMaybe<ReadonlyArray<RateReportPurpose>>;
};

export type RateReportLabelUpdates = {
  readonly code?: InputMaybe<Scalars['String']['input']>;
  readonly hint?: InputMaybe<Scalars['String']['input']>;
  readonly isActive?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export enum RateReportPurpose {
  Proposal = 'PROPOSAL',
  Qa = 'QA'
}

export type RateRuleInput = {
  readonly filter: GeneralLedgerFilterInput;
  readonly isActive?: InputMaybe<Scalars['Boolean']['input']>;
  readonly mapping: RateMappingInput;
  readonly name: Scalars['String']['input'];
  readonly priority: Scalars['Float']['input'];
};

export type RateRuleUpdates = {
  readonly filter?: InputMaybe<GeneralLedgerFilterInput>;
  readonly isActive?: InputMaybe<Scalars['Boolean']['input']>;
  readonly mapping?: InputMaybe<RateMappingInput>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly priority?: InputMaybe<Scalars['Float']['input']>;
};

export type RelayCommandInput = {
  readonly operation?: InputMaybe<Scalars['ID']['input']>;
  readonly payload?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export enum ReportCellStyle {
  ColumnHeader = 'COLUMN_HEADER',
  Divider = 'DIVIDER',
  GrandTotal = 'GRAND_TOTAL',
  Label = 'LABEL',
  ReportHeader = 'REPORT_HEADER',
  SectionHeader = 'SECTION_HEADER',
  SubsectionHeader = 'SUBSECTION_HEADER',
  Subtotal = 'SUBTOTAL'
}

export type RoleInput = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly statements: ReadonlyArray<PolicyStatementInput>;
  readonly tenantId?: InputMaybe<Scalars['ID']['input']>;
};

export type RoleUpdates = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly statements?: InputMaybe<ReadonlyArray<PolicyStatementInput>>;
};

export enum RoomTypeCategory {
  Lab = 'LAB',
  LabService = 'LAB_SERVICE',
  Standard = 'STANDARD'
}

export type ScenarioInput = {
  readonly alias: Scalars['String']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly period?: InputMaybe<PeriodInput>;
  readonly purposes?: InputMaybe<SelectedPurposesInput>;
  readonly variables?: InputMaybe<ReadonlyArray<VariableValueInput>>;
  readonly visibility?: InputMaybe<ScenarioVisibility>;
};

export type ScenarioUpdates = {
  readonly alias?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly variables?: InputMaybe<ReadonlyArray<VariableValueInput>>;
  readonly visibility?: InputMaybe<ScenarioVisibility>;
};

export enum ScenarioVisibility {
  Hidden = 'HIDDEN',
  Pinned = 'PINNED',
  Visible = 'VISIBLE'
}

export type ScopeValueInput = {
  readonly value: Scalars['ID']['input'];
  readonly variable: Scalars['String']['input'];
};

export type SelectedPurposesInput = {
  readonly prefer?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly require?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type ServiceCenterInput = {
  readonly functionalizations: ReadonlyArray<SpaceFunctionalizationInput>;
  readonly name: Scalars['String']['input'];
};

export type SimulateCheckInput = {
  readonly action: Scalars['String']['input'];
  readonly resource?: InputMaybe<SimulateResourceInput>;
};

export type SimulateResourceInput = {
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly type: PolicyResourceType;
};

export type SpaceAccountListFilterInput = {
  readonly organizationFilter?: InputMaybe<SpaceRecordsDimensionFilterInput>;
};

export type SpaceEmployeeFilter = {
  readonly isOccupant?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isSponsored?: InputMaybe<Scalars['Boolean']['input']>;
  readonly jobTitleId?: InputMaybe<Scalars['ID']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly orgFilter?: InputMaybe<SpaceEmployeeOrgFilter>;
  readonly search?: InputMaybe<Scalars['String']['input']>;
};

export type SpaceEmployeeInput = {
  readonly jobTitleId?: InputMaybe<Scalars['ID']['input']>;
  readonly name: Scalars['String']['input'];
  readonly organization: SpaceEmployeeOrgReferenceInput;
};

export type SpaceEmployeeListFilterInput = {
  readonly organizationFilter?: InputMaybe<SpaceRecordsDimensionFilterInput>;
};

export type SpaceEmployeeOrgFilter = {
  readonly entityId: Scalars['ID']['input'];
  readonly recordIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type SpaceEmployeeOrgReferenceInput = {
  readonly entityId: Scalars['ID']['input'];
  readonly recordId: Scalars['ID']['input'];
};

export type SpaceFunctionalizationInput = {
  readonly functionId: Scalars['ID']['input'];
  readonly percent: Scalars['Float']['input'];
};

export type SpacePayrollsFilterInput = {
  readonly organizationFilter?: InputMaybe<SpaceRecordsDimensionFilterInput>;
};

export type SpacePayrollsPaginationInput = {
  readonly quantity?: InputMaybe<Scalars['Int']['input']>;
  readonly skip?: InputMaybe<Scalars['Int']['input']>;
};

export type SpacePayrollsSortInput = {
  readonly by: Scalars['String']['input'];
  readonly descending?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SpaceRecordFunctionalMethodology {
  AutoLabBased = 'AUTO_LAB_BASED',
  JointUse = 'JOINT_USE',
  Manual = 'MANUAL',
  ServiceCenter = 'SERVICE_CENTER',
  Unassignable = 'UNASSIGNABLE',
  Vacant = 'VACANT'
}

export type SpaceRecordFunctionalUsageUpdate = {
  readonly functionalizationMethodology: SpaceRecordFunctionalMethodology;
  readonly functionalizations?: InputMaybe<ReadonlyArray<SpaceFunctionalizationInput>>;
  readonly serviceCenterId?: InputMaybe<Scalars['ID']['input']>;
};

export enum SpaceRecordHistoryAction {
  ClusterAssigned = 'CLUSTER_ASSIGNED',
  ClusterRemoved = 'CLUSTER_REMOVED',
  FunctionalUsageUpdated = 'FUNCTIONAL_USAGE_UPDATED',
  LabsUpdated = 'LABS_UPDATED',
  OccupantsUpdated = 'OCCUPANTS_UPDATED',
  OrganizationAssignUpdated = 'ORGANIZATION_ASSIGN_UPDATED',
  ResponsiblePersonsUpdated = 'RESPONSIBLE_PERSONS_UPDATED',
  SignedOff = 'SIGNED_OFF',
  SignedOffLite = 'SIGNED_OFF_LITE',
  Unlocked = 'UNLOCKED',
  Updated = 'UPDATED'
}

export type SpaceRecordUpdate = {
  readonly anomalies?: InputMaybe<ReadonlyArray<Anomaly>>;
  readonly comment?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly roomTypeId?: InputMaybe<Scalars['ID']['input']>;
};

export type SpaceRecordsDimensionFilterInput = {
  readonly entityId: Scalars['ID']['input'];
  readonly recordIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type SpaceRecordsFilterInput = {
  readonly clusterFilter?: InputMaybe<SpaceRecordsDimensionFilterInput>;
  readonly includeInaccessible?: InputMaybe<Scalars['Boolean']['input']>;
  readonly lastUpdatedBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly orgFilter?: InputMaybe<SpaceRecordsDimensionFilterInput>;
  readonly responsiblePersonFilter?: InputMaybe<SpaceRecordsDimensionFilterInput>;
  readonly roomTypeCategories?: InputMaybe<ReadonlyArray<InputMaybe<RoomTypeCategory>>>;
  readonly roomTypeFilter?: InputMaybe<SpaceRecordsDimensionFilterInput>;
  readonly spaceFilter?: InputMaybe<SpaceRecordsDimensionFilterInput>;
  readonly sqftMax?: InputMaybe<Scalars['Float']['input']>;
  readonly sqftMin?: InputMaybe<Scalars['Float']['input']>;
  readonly surveyStatuses?: InputMaybe<ReadonlyArray<InputMaybe<SurveyStatus>>>;
  readonly surveyStatusesLite?: InputMaybe<ReadonlyArray<InputMaybe<SurveyStatus>>>;
};

export type SpaceRecordsPaginationInput = {
  readonly quantity?: InputMaybe<Scalars['Int']['input']>;
  readonly skip?: InputMaybe<Scalars['Int']['input']>;
};

export type SpaceRecordsSortInput = {
  readonly by: Scalars['String']['input'];
  readonly descending?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpaceReportAccountListConfigurationInput = {
  readonly filter: SpaceAccountListFilterInput;
  readonly format: SpaceReportFormat;
};

export type SpaceReportConfigurationInput = {
  readonly accountList?: InputMaybe<SpaceReportAccountListConfigurationInput>;
  readonly dataExport?: InputMaybe<SpaceReportDataExportConfigurationInput>;
  readonly employeeList?: InputMaybe<SpaceReportEmployeeListConfigurationInput>;
  readonly progressByOrganization?: InputMaybe<SpaceReportProgressByOrganizationConfigurationInput>;
  readonly roomLinks?: InputMaybe<SpaceReportRoomLinksConfigurationInput>;
  readonly roomSupportingInformation?: InputMaybe<SpaceReportRoomSupportingInformationConfigurationInput>;
  readonly roomsByAccount?: InputMaybe<SpaceReportRoomsByAccountConfigurationInput>;
  readonly roomsByOccupant?: InputMaybe<SpaceReportRoomsByOccupantConfigurationInput>;
  readonly roomsByResponsiblePerson?: InputMaybe<SpaceReportRoomsByResponsiblePersonConfigurationInput>;
  readonly spaceSalaryComparison?: InputMaybe<SpaceReportSpaceSalaryComparisonConfigurationInput>;
  readonly unassignedSponsoredAccounts?: InputMaybe<SpaceReportUnassignedSponsoredAccountsConfigurationInput>;
  readonly unassignedSponsoredPeople?: InputMaybe<SpaceReportUnassignedSponsoredPeopleConfigurationInput>;
  readonly unclaimedRooms?: InputMaybe<SpaceReportUnclaimedRoomsConfigurationInput>;
};

export type SpaceReportDataExportConfigurationInput = {
  readonly accountFields?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly accountLayout?: InputMaybe<SpaceReportDataExportLayout>;
  readonly fields?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly filter: SpaceReportDataExportFilterInput;
  readonly functionalUsageFields?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly functionalUsageLayout?: InputMaybe<SpaceReportDataExportLayout>;
  readonly occupantFields?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly occupantLayout?: InputMaybe<SpaceReportDataExportLayout>;
  readonly responsiblePersonFields?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly responsiblePersonLayout?: InputMaybe<SpaceReportDataExportLayout>;
};

export type SpaceReportDataExportFilterInput = {
  readonly clusterFilter?: InputMaybe<SpaceRecordsDimensionFilterInput>;
  readonly organizationFilter?: InputMaybe<SpaceRecordsDimensionFilterInput>;
  readonly spaceFilter?: InputMaybe<SpaceRecordsDimensionFilterInput>;
};

export enum SpaceReportDataExportLayout {
  Columns = 'COLUMNS',
  Rows = 'ROWS'
}

export type SpaceReportEmployeeListConfigurationInput = {
  readonly filter: SpaceEmployeeListFilterInput;
  readonly format: SpaceReportFormat;
  readonly showSalaryInformation: Scalars['Boolean']['input'];
};

export enum SpaceReportFormat {
  Excel = 'EXCEL',
  Html = 'HTML',
  Pdf = 'PDF'
}

export enum SpaceReportId {
  AccountList = 'ACCOUNT_LIST',
  DataExport = 'DATA_EXPORT',
  EmployeeList = 'EMPLOYEE_LIST',
  ProgressByOrganization = 'PROGRESS_BY_ORGANIZATION',
  RoomsByAccount = 'ROOMS_BY_ACCOUNT',
  RoomsByOccupant = 'ROOMS_BY_OCCUPANT',
  RoomsByResponsiblePerson = 'ROOMS_BY_RESPONSIBLE_PERSON',
  RoomLinks = 'ROOM_LINKS',
  RoomSupportingInformation = 'ROOM_SUPPORTING_INFORMATION',
  SpaceSalaryComparison = 'SPACE_SALARY_COMPARISON',
  UnassignedSponsoredAccounts = 'UNASSIGNED_SPONSORED_ACCOUNTS',
  UnassignedSponsoredPeople = 'UNASSIGNED_SPONSORED_PEOPLE',
  UnclaimedRooms = 'UNCLAIMED_ROOMS'
}

export type SpaceReportProgressByOrganizationConfigurationInput = {
  readonly entityId: Scalars['ID']['input'];
  readonly format: SpaceReportFormat;
};

export type SpaceReportRoomLinksConfigurationInput = {
  readonly format: SpaceReportFormat;
};

export type SpaceReportRoomSupportingInformationConfigurationInput = {
  readonly filter: SpaceReportRoomSupportingInformationFilterInput;
  readonly format: SpaceReportFormat;
  readonly showCalculatedRoomFunctionalPercentages: Scalars['Boolean']['input'];
  readonly showEmployeeNumbers: Scalars['Boolean']['input'];
  readonly showProjectInformation: Scalars['Boolean']['input'];
  readonly showSalaryInformation: Scalars['Boolean']['input'];
  readonly sortBy: SpaceReportRoomSupportingInformationSortBy;
};

export type SpaceReportRoomSupportingInformationFilterInput = {
  readonly clusterFilter?: InputMaybe<SpaceRecordsDimensionFilterInput>;
  readonly employeeFilter?: InputMaybe<SpaceRecordsDimensionFilterInput>;
  readonly functionalMethodologies?: InputMaybe<ReadonlyArray<SpaceRecordFunctionalMethodology>>;
  readonly organizationFilter?: InputMaybe<SpaceRecordsDimensionFilterInput>;
  readonly roomTypeFilter?: InputMaybe<SpaceRecordsDimensionFilterInput>;
  readonly spaceFilter?: InputMaybe<SpaceRecordsDimensionFilterInput>;
};

export enum SpaceReportRoomSupportingInformationSortBy {
  Building = 'BUILDING',
  ResponsiblePerson = 'RESPONSIBLE_PERSON'
}

export type SpaceReportRoomsByAccountConfigurationInput = {
  readonly filter: SpaceRoomsByAccountFilterInput;
  readonly format: SpaceReportFormat;
};

export type SpaceReportRoomsByOccupantConfigurationInput = {
  readonly filter: SpaceRoomsByOccupantFilterInput;
  readonly format: SpaceReportFormat;
};

export type SpaceReportRoomsByResponsiblePersonConfigurationInput = {
  readonly filter: SpaceRoomsByResponsiblePersonFilterInput;
  readonly format: SpaceReportFormat;
};

export type SpaceReportSpaceSalaryComparisonConfigurationInput = {
  readonly filter: SpaceSalaryComparisonFilterInput;
  readonly format: SpaceReportFormat;
};

export type SpaceReportUnassignedSponsoredAccountsConfigurationInput = {
  readonly filter: SpacePayrollsFilterInput;
  readonly showSalaryInformation: Scalars['Boolean']['input'];
};

export type SpaceReportUnassignedSponsoredPeopleConfigurationInput = {
  readonly filter: SpacePayrollsFilterInput;
  readonly showSalaryInformation: Scalars['Boolean']['input'];
};

export type SpaceReportUnclaimedRoomsConfigurationInput = {
  readonly format: SpaceReportFormat;
};

export type SpaceResponsiblePersonInput = {
  readonly isPrimary: Scalars['Boolean']['input'];
};

export type SpaceRoomsByAccountFilterInput = {
  readonly accountFilter?: InputMaybe<SpaceRecordsDimensionFilterInput>;
};

export type SpaceRoomsByOccupantFilterInput = {
  readonly employeeFilter?: InputMaybe<SpaceRecordsDimensionFilterInput>;
};

export type SpaceRoomsByResponsiblePersonFilterInput = {
  readonly employeeFilter?: InputMaybe<SpaceRecordsDimensionFilterInput>;
};

export type SpaceSalaryComparisonFilterInput = {
  readonly organizationFilter?: InputMaybe<SpaceRecordsDimensionFilterInput>;
};

export type SpaceSurveyConfigurationFunctionalUsageInput = {
  readonly requireFunctionalUsageAssignmentsForSelectedAccounts: Scalars['Boolean']['input'];
  readonly requireSponsoredAccountAssignmentsForSponsoredFunctionalUsages: Scalars['Boolean']['input'];
};

export type SpaceSurveyConfigurationInput = {
  readonly functionalUsage?: InputMaybe<SpaceSurveyConfigurationFunctionalUsageInput>;
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly tools: SpaceSurveyConfigurationToolsInput;
};

export type SpaceSurveyConfigurationToolsInput = {
  readonly allowUsersToUnlockRoomsDirectly: Scalars['Boolean']['input'];
};

export enum SpaceWarningCode {
  ExclusiveFunctionsForNonExclusiveMethodology = 'exclusiveFunctionsForNonExclusiveMethodology',
  FunctionalUsageNotFullyCoded = 'functionalUsageNotFullyCoded',
  InvalidFunctionalizationsForExclusiveMethodology = 'invalidFunctionalizationsForExclusiveMethodology',
  MissingFunctionalUsagesForSelectedAccounts = 'missingFunctionalUsagesForSelectedAccounts',
  MissingSponsoredAccountsForSponsoredFunctionalUsages = 'missingSponsoredAccountsForSponsoredFunctionalUsages'
}

export enum SurveyStatus {
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  SignedOff = 'SIGNED_OFF'
}

export type TagInput = {
  readonly key: Scalars['String']['input'];
  readonly value?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type TenantInput = {
  readonly alias: Scalars['String']['input'];
  readonly code: Scalars['String']['input'];
  readonly color?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
};

export type TenantUpdates = {
  readonly alias?: InputMaybe<Scalars['String']['input']>;
  readonly code?: InputMaybe<Scalars['String']['input']>;
  readonly color?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export enum TextAlignment {
  Center = 'CENTER',
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type UserInput = {
  readonly email: Scalars['AWSEmail']['input'];
  readonly employeeId?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly isPlatformAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isTenant?: InputMaybe<Scalars['Boolean']['input']>;
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber?: InputMaybe<Scalars['AWSPhone']['input']>;
  readonly tags?: InputMaybe<ReadonlyArray<InputMaybe<TagInput>>>;
};

export type UserUpdates = {
  readonly email?: InputMaybe<Scalars['AWSEmail']['input']>;
  readonly employeeId?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly isPlatformAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber?: InputMaybe<Scalars['AWSPhone']['input']>;
  readonly tags?: InputMaybe<ReadonlyArray<InputMaybe<TagInput>>>;
};

export type ValueConstraintsInput = {
  readonly acceptable?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['AWSJSON']['input']>>>;
  readonly max?: InputMaybe<Scalars['AWSJSON']['input']>;
  readonly maxLength?: InputMaybe<Scalars['Int']['input']>;
  readonly min?: InputMaybe<Scalars['AWSJSON']['input']>;
  readonly minLength?: InputMaybe<Scalars['Int']['input']>;
  readonly pattern?: InputMaybe<Scalars['String']['input']>;
  readonly unacceptable?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['AWSJSON']['input']>>>;
};

export type VariableInput = {
  readonly defaultValue?: InputMaybe<Scalars['AWSJSON']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly name: Scalars['String']['input'];
  readonly type?: InputMaybe<DmsValueTypeInput>;
};

export type VariableValueInput = {
  readonly value?: InputMaybe<Scalars['AWSJSON']['input']>;
  readonly variable: Scalars['ID']['input'];
};

export enum Void {
  Void = 'VOID'
}

export type ZoneInput = {
  readonly alias: Scalars['String']['input'];
  readonly code: Scalars['String']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
};

export type ZoneUpdates = {
  readonly alias?: InputMaybe<Scalars['String']['input']>;
  readonly code?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type FragmentUserForAgentAssignmentFragment = { readonly id: string, readonly lastName?: string | null, readonly firstName?: string | null, readonly isPlatformAdmin?: boolean | null };

export type AssignAgentAccessMutationVariables = Exact<{
  assignments: ReadonlyArray<AccessAssignment> | AccessAssignment;
}>;


export type AssignAgentAccessMutation = { readonly assignAccess?: boolean | null };

export type UsersForAgentAssignmentInAppQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersForAgentAssignmentInAppQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly users?: { readonly nextCursor?: string | null, readonly items: ReadonlyArray<{ readonly appAccess?: number | null, readonly info?: { readonly id: string, readonly lastName?: string | null, readonly firstName?: string | null, readonly isPlatformAdmin?: boolean | null } | null } | null> } | null } | null } | null } | null };

export type UsersForAgentAssignmentInTenantQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersForAgentAssignmentInTenantQuery = { readonly tenant?: { readonly users?: { readonly nextCursor?: string | null, readonly items: ReadonlyArray<{ readonly tenantAccess?: number | null, readonly info?: { readonly id: string, readonly lastName?: string | null, readonly firstName?: string | null, readonly isPlatformAdmin?: boolean | null } | null } | null> } | null } | null };

export type UsersForAgentAssignmentInZoneQueryVariables = Exact<{
  zoneId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersForAgentAssignmentInZoneQuery = { readonly tenant?: { readonly zone?: { readonly users?: { readonly nextCursor?: string | null, readonly items: ReadonlyArray<{ readonly zoneAccess?: number | null, readonly info?: { readonly id: string, readonly lastName?: string | null, readonly firstName?: string | null, readonly isPlatformAdmin?: boolean | null } | null } | null> } | null } | null } | null };

export type UsersForAgentAssignmentQueryVariables = Exact<{
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersForAgentAssignmentQuery = { readonly users?: { readonly nextCursor?: string | null, readonly items: ReadonlyArray<{ readonly id: string, readonly lastName?: string | null, readonly firstName?: string | null, readonly isPlatformAdmin?: boolean | null } | null> } | null };

export type AgentAssignmentsInAppQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
}>;


export type AgentAssignmentsInAppQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly users?: { readonly items: ReadonlyArray<{ readonly info?: { readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null, readonly agents?: ReadonlyArray<{ readonly id: string, readonly access: number }> | null } | null> } | null } | null } | null } | null };

export type AgentAssignmentsInTenantQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
}>;


export type AgentAssignmentsInTenantQuery = { readonly tenant?: { readonly users?: { readonly items: ReadonlyArray<{ readonly info?: { readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null, readonly agents?: ReadonlyArray<{ readonly id: string, readonly access: number }> | null } | null> } | null } | null };

export type AgentAssignmentsInZoneQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
}>;


export type AgentAssignmentsInZoneQuery = { readonly tenant?: { readonly zone?: { readonly users?: { readonly items: ReadonlyArray<{ readonly info?: { readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null, readonly agents?: ReadonlyArray<{ readonly id: string, readonly access: number }> | null } | null> } | null } | null } | null };

export type CreateAdminAgentKnowledgeBaseUploadRequestMutationVariables = Exact<{
  input: AdminAgentKnowledgeBaseUploadInput;
}>;


export type CreateAdminAgentKnowledgeBaseUploadRequestMutation = { readonly createAdminAgentKnowledgeBaseUploadRequest: { readonly url?: any | null, readonly fields?: ReadonlyArray<{ readonly id?: string | null, readonly value?: string | null } | null> | null } };

export type DeleteAdminAgentKnowledgeBaseFileMutationVariables = Exact<{
  input: AdminAgentKnowledgeBaseFileTargetInput;
}>;


export type DeleteAdminAgentKnowledgeBaseFileMutation = { readonly deleteAdminAgentKnowledgeBaseFile: boolean };

export type AdminAgentKnowledgeBaseDownloadUrlQueryVariables = Exact<{
  input: AdminAgentKnowledgeBaseFileTargetInput;
}>;


export type AdminAgentKnowledgeBaseDownloadUrlQuery = { readonly adminAgentKnowledgeBaseDownloadUrl: any };

export type AdminAgentKnowledgeBaseManagementQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminAgentKnowledgeBaseManagementQuery = { readonly adminAgentKnowledgeBaseManagement: { readonly agents: ReadonlyArray<{ readonly agentId: string, readonly agentName: string, readonly dataSources: ReadonlyArray<{ readonly description?: string | null, readonly id: string, readonly knowledgeBaseId: string }> }>, readonly sharedDataSource: { readonly description?: string | null, readonly id: string, readonly knowledgeBaseId: string } } };

export type AdminAgentKnowledgeBaseFilesQueryVariables = Exact<{
  input: AdminAgentKnowledgeBaseFileListInput;
}>;


export type AdminAgentKnowledgeBaseFilesQuery = { readonly adminAgentKnowledgeBaseFiles: ReadonlyArray<{ readonly canDelete: boolean, readonly dataSourceId: string, readonly key: string, readonly knowledgeBaseId: string, readonly lastModifiedAt?: any | null, readonly name: string, readonly sizeBytes: number }> };

export type FragmentAppPageFragment = { readonly id?: string | null, readonly alias?: string | null, readonly pageId?: string | null, readonly name?: string | null, readonly description?: string | null, readonly display?: { readonly isMain?: boolean | null, readonly position?: number | null } | null };

export type AddPagesMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  input: ReadonlyArray<AppPageInput> | AppPageInput;
}>;


export type AddPagesMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly addPages?: ReadonlyArray<{ readonly id?: string | null, readonly alias?: string | null, readonly pageId?: string | null, readonly name?: string | null, readonly description?: string | null, readonly display?: { readonly isMain?: boolean | null, readonly position?: number | null } | null } | null> | null } | null } | null } | null };

export type RemovePagesMutationVariables = Exact<{
  removePageIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
}>;


export type RemovePagesMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly removePages?: ReadonlyArray<string | null> | null } | null } | null } | null };

export type UpdatePageMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  updates: AppPageUpdates;
  updatePageId: Scalars['ID']['input'];
}>;


export type UpdatePageMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly updatePage?: { readonly id?: string | null, readonly alias?: string | null, readonly pageId?: string | null, readonly name?: string | null, readonly description?: string | null, readonly display?: { readonly isMain?: boolean | null, readonly position?: number | null } | null } | null } | null } | null } | null };

export type AppPagesQueryVariables = Exact<{
  zoneId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
}>;


export type AppPagesQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly pages?: ReadonlyArray<{ readonly id?: string | null, readonly alias?: string | null, readonly pageId?: string | null, readonly name?: string | null, readonly description?: string | null, readonly display?: { readonly isMain?: boolean | null, readonly position?: number | null } | null } | null> | null } | null } | null } | null };

export type CreateAppMutationVariables = Exact<{
  input: AppInput;
  zoneId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
}>;


export type CreateAppMutation = { readonly tenant?: { readonly zone?: { readonly createApp?: { readonly alias?: string | null, readonly id: string, readonly name?: string | null, readonly icon?: string | null, readonly description?: string | null, readonly createdBy?: string | null, readonly supportsFunctionalityConfiguration?: boolean | null, readonly supportsScenarios?: boolean | null, readonly sessionVariables?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null, readonly defaultValue?: any | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsInlineEnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null }> | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsMultiReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null } | null> | null } | null } | null } | null };

export type DeleteAppMutationVariables = Exact<{
  deleteAppId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
}>;


export type DeleteAppMutation = { readonly tenant?: { readonly zone?: { readonly deleteApp?: { readonly id: string } | null } | null } | null };

export type UpdateAppMutationVariables = Exact<{
  updateAppId: Scalars['ID']['input'];
  updates: AppUpdates;
  zoneId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
}>;


export type UpdateAppMutation = { readonly tenant?: { readonly zone?: { readonly updateApp?: { readonly alias?: string | null, readonly id: string, readonly name?: string | null, readonly icon?: string | null, readonly description?: string | null, readonly createdBy?: string | null, readonly supportsFunctionalityConfiguration?: boolean | null, readonly supportsScenarios?: boolean | null, readonly sessionVariables?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null, readonly defaultValue?: any | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsInlineEnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null }> | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsMultiReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null } | null> | null } | null } | null } | null };

export type AppsQueryVariables = Exact<{
  zoneId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
}>;


export type AppsQuery = { readonly tenant?: { readonly zone?: { readonly apps?: { readonly nextCursor?: string | null, readonly items?: ReadonlyArray<{ readonly id: string, readonly alias?: string | null, readonly description?: string | null, readonly icon?: string | null, readonly name?: string | null, readonly createdBy?: string | null, readonly supportsScenarios?: boolean | null, readonly supportsFunctionalityConfiguration?: boolean | null, readonly sessionVariables?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null, readonly defaultValue?: any | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsInlineEnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null }> | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsMultiReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null } | null> | null } | null> | null } | null } | null } | null };

export type AdminPagesQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
}>;


export type AdminPagesQuery = { readonly tenant?: { readonly zone?: { readonly mosaicDev?: { readonly pages?: ReadonlyArray<{ readonly id: string, readonly name?: string | null } | null> | null } | null } | null } | null };

export type AdminScenariosQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
}>;


export type AdminScenariosQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenarios?: { readonly nextCursor?: string | null, readonly items?: ReadonlyArray<{ readonly id: string, readonly alias?: string | null, readonly name?: string | null, readonly description?: string | null, readonly createdBy?: string | null, readonly visibility?: ScenarioVisibility | null, readonly period?: { readonly startDate?: any | null, readonly endDate?: any | null } | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null> | null } | null } | null } | null } | null };

export type CreateTenantMutationVariables = Exact<{
  input: TenantInput;
}>;


export type CreateTenantMutation = { readonly createTenant?: { readonly id: string, readonly alias?: string | null, readonly code?: string | null, readonly name?: string | null, readonly color?: string | null, readonly createdBy?: string | null, readonly monthlyCreditLimit?: number | null } | null };

export type DeleteTenantMutationVariables = Exact<{
  deleteTenantId: Scalars['ID']['input'];
}>;


export type DeleteTenantMutation = { readonly deleteTenant?: { readonly id: string } | null };

export type UpdateTenantMutationVariables = Exact<{
  updateTenantId: Scalars['ID']['input'];
  updates: TenantUpdates;
}>;


export type UpdateTenantMutation = { readonly updateTenant?: { readonly id: string, readonly code?: string | null, readonly alias?: string | null, readonly color?: string | null, readonly name?: string | null, readonly createdBy?: string | null, readonly monthlyCreditLimit?: number | null } | null };

export type TenantsQueryVariables = Exact<{
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type TenantsQuery = { readonly tenants?: { readonly nextCursor?: string | null, readonly items?: ReadonlyArray<{ readonly id: string, readonly code?: string | null, readonly alias?: string | null, readonly name?: string | null, readonly color?: string | null, readonly createdBy?: string | null, readonly monthlyCreditLimit?: number | null } | null> | null } | null };

export type FragmentUserForAssignmentFragment = { readonly id: string, readonly lastName?: string | null, readonly firstName?: string | null, readonly isPlatformAdmin?: boolean | null };

export type AssignAccessMutationVariables = Exact<{
  assignments: ReadonlyArray<AccessAssignment> | AccessAssignment;
}>;


export type AssignAccessMutation = { readonly assignAccess?: boolean | null };

export type UsersForAssignmentInAppQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersForAssignmentInAppQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly users?: { readonly nextCursor?: string | null, readonly items: ReadonlyArray<{ readonly appAccess?: number | null, readonly info?: { readonly id: string, readonly lastName?: string | null, readonly firstName?: string | null, readonly isPlatformAdmin?: boolean | null } | null } | null> } | null } | null } | null } | null };

export type UsersForAssignmentInTenantQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersForAssignmentInTenantQuery = { readonly tenant?: { readonly users?: { readonly nextCursor?: string | null, readonly items: ReadonlyArray<{ readonly tenantAccess?: number | null, readonly info?: { readonly id: string, readonly lastName?: string | null, readonly firstName?: string | null, readonly isPlatformAdmin?: boolean | null } | null } | null> } | null } | null };

export type UsersForAssignmentInZoneQueryVariables = Exact<{
  zoneId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersForAssignmentInZoneQuery = { readonly tenant?: { readonly zone?: { readonly users?: { readonly nextCursor?: string | null, readonly items: ReadonlyArray<{ readonly zoneAccess?: number | null, readonly info?: { readonly id: string, readonly lastName?: string | null, readonly firstName?: string | null, readonly isPlatformAdmin?: boolean | null } | null } | null> } | null } | null } | null };

export type UsersForAssignmentQueryVariables = Exact<{
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersForAssignmentQuery = { readonly users?: { readonly nextCursor?: string | null, readonly items: ReadonlyArray<{ readonly id: string, readonly lastName?: string | null, readonly firstName?: string | null, readonly isPlatformAdmin?: boolean | null } | null> } | null };

export type FragmentShareableUserInfoFragment = { readonly id?: string | null, readonly name?: string | null };

export type FragmentUserFragment = { readonly id: string, readonly lastName?: string | null, readonly firstName?: string | null, readonly email?: any | null, readonly jobTitle?: string | null, readonly employeeId?: string | null, readonly isPlatformAdmin?: boolean | null, readonly isTenant?: boolean | null, readonly phoneNumber?: any | null, readonly tags?: ReadonlyArray<{ readonly value?: any | null, readonly key?: string | null } | null> | null };

export type CreateUserMutationVariables = Exact<{
  info: UserInput;
  tenantContextId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateUserMutation = { readonly createUser?: { readonly id: string, readonly lastName?: string | null, readonly firstName?: string | null, readonly email?: any | null, readonly jobTitle?: string | null, readonly employeeId?: string | null, readonly isPlatformAdmin?: boolean | null, readonly isTenant?: boolean | null, readonly phoneNumber?: any | null, readonly tags?: ReadonlyArray<{ readonly value?: any | null, readonly key?: string | null } | null> | null } | null };

export type DeleteUserMutationVariables = Exact<{
  deleteUserId: Scalars['ID']['input'];
}>;


export type DeleteUserMutation = { readonly deleteUser?: { readonly id: string } | null };

export type UpdateUserMutationVariables = Exact<{
  updateUserId: Scalars['ID']['input'];
  updates: UserUpdates;
}>;


export type UpdateUserMutation = { readonly updateUser?: { readonly id: string, readonly lastName?: string | null, readonly firstName?: string | null, readonly email?: any | null, readonly jobTitle?: string | null, readonly employeeId?: string | null, readonly isPlatformAdmin?: boolean | null, readonly isTenant?: boolean | null, readonly phoneNumber?: any | null, readonly tags?: ReadonlyArray<{ readonly value?: any | null, readonly key?: string | null } | null> | null } | null };

export type UsersInAppQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersInAppQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly users?: { readonly nextCursor?: string | null, readonly items: ReadonlyArray<{ readonly appAccess?: number | null, readonly info?: { readonly id: string, readonly lastName?: string | null, readonly firstName?: string | null, readonly email?: any | null, readonly jobTitle?: string | null, readonly employeeId?: string | null, readonly isPlatformAdmin?: boolean | null, readonly isTenant?: boolean | null, readonly phoneNumber?: any | null, readonly tags?: ReadonlyArray<{ readonly value?: any | null, readonly key?: string | null } | null> | null } | null } | null> } | null } | null } | null } | null };

export type UsersInScenarioQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersInScenarioQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly users?: { readonly nextCursor?: string | null, readonly items: ReadonlyArray<{ readonly scenarioAccess?: number | null, readonly info?: { readonly id: string, readonly lastName?: string | null, readonly firstName?: string | null, readonly email?: any | null, readonly jobTitle?: string | null, readonly employeeId?: string | null, readonly isPlatformAdmin?: boolean | null, readonly isTenant?: boolean | null, readonly phoneNumber?: any | null, readonly tags?: ReadonlyArray<{ readonly value?: any | null, readonly key?: string | null } | null> | null } | null } | null> } | null } | null } | null } | null } | null };

export type UsersInTenantQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersInTenantQuery = { readonly tenant?: { readonly users?: { readonly nextCursor?: string | null, readonly items: ReadonlyArray<{ readonly tenantAccess?: number | null, readonly info?: { readonly id: string, readonly lastName?: string | null, readonly firstName?: string | null, readonly email?: any | null, readonly jobTitle?: string | null, readonly employeeId?: string | null, readonly isPlatformAdmin?: boolean | null, readonly isTenant?: boolean | null, readonly phoneNumber?: any | null, readonly tags?: ReadonlyArray<{ readonly value?: any | null, readonly key?: string | null } | null> | null } | null } | null> } | null } | null };

export type UsersInZoneQueryVariables = Exact<{
  zoneId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersInZoneQuery = { readonly tenant?: { readonly zone?: { readonly users?: { readonly nextCursor?: string | null, readonly items: ReadonlyArray<{ readonly zoneAccess?: number | null, readonly info?: { readonly id: string, readonly lastName?: string | null, readonly firstName?: string | null, readonly email?: any | null, readonly jobTitle?: string | null, readonly employeeId?: string | null, readonly isPlatformAdmin?: boolean | null, readonly isTenant?: boolean | null, readonly phoneNumber?: any | null, readonly tags?: ReadonlyArray<{ readonly value?: any | null, readonly key?: string | null } | null> | null } | null } | null> } | null } | null } | null };

export type UsersQueryVariables = Exact<{
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersQuery = { readonly users?: { readonly nextCursor?: string | null, readonly items: ReadonlyArray<{ readonly id: string, readonly lastName?: string | null, readonly firstName?: string | null, readonly email?: any | null, readonly jobTitle?: string | null, readonly employeeId?: string | null, readonly isPlatformAdmin?: boolean | null, readonly isTenant?: boolean | null, readonly phoneNumber?: any | null, readonly tags?: ReadonlyArray<{ readonly value?: any | null, readonly key?: string | null } | null> | null } | null> } | null };

export type CreateZoneMutationVariables = Exact<{
  input: ZoneInput;
  tenantId: Scalars['ID']['input'];
}>;


export type CreateZoneMutation = { readonly tenant?: { readonly createZone?: { readonly alias?: string | null, readonly id: string, readonly code?: string | null, readonly description?: string | null, readonly name?: string | null, readonly createdBy?: string | null } | null } | null };

export type DeleteZoneMutationVariables = Exact<{
  deleteZoneId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
}>;


export type DeleteZoneMutation = { readonly tenant?: { readonly deleteZone?: { readonly id: string } | null } | null };

export type UpdateZoneMutationVariables = Exact<{
  updateZoneId: Scalars['ID']['input'];
  updates: ZoneUpdates;
  tenantId: Scalars['ID']['input'];
}>;


export type UpdateZoneMutation = { readonly tenant?: { readonly updateZone?: { readonly id: string, readonly code?: string | null, readonly alias?: string | null, readonly name?: string | null, readonly description?: string | null, readonly createdBy?: string | null } | null } | null };

export type ZonesQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type ZonesQuery = { readonly tenant?: { readonly zones?: { readonly nextCursor?: string | null, readonly items?: ReadonlyArray<{ readonly id: string, readonly alias?: string | null, readonly code?: string | null, readonly description?: string | null, readonly name?: string | null, readonly createdBy?: string | null } | null> | null } | null } | null };

export type FragmentApiKeyFragment = { readonly id: string, readonly name?: string | null, readonly enabled: boolean, readonly createdAt: any, readonly expiresAt?: any | null, readonly lastUsedAt?: any | null };

export type GenerateApiKeyMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
}>;


export type GenerateApiKeyMutation = { readonly tenant?: { readonly zone?: { readonly generateApiKey: { readonly key: string, readonly apiKey: { readonly id: string, readonly name?: string | null, readonly enabled: boolean, readonly createdAt: any, readonly expiresAt?: any | null, readonly lastUsedAt?: any | null } } } | null } | null };

export type RevokeApiKeyMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type RevokeApiKeyMutation = { readonly tenant?: { readonly zone?: { readonly revokeApiKey?: Void | null } | null } | null };

export type ApiKeysQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
}>;


export type ApiKeysQuery = { readonly tenant?: { readonly zone?: { readonly apiKeys: ReadonlyArray<{ readonly id: string, readonly name?: string | null, readonly enabled: boolean, readonly createdAt: any, readonly expiresAt?: any | null, readonly lastUsedAt?: any | null }> } | null } | null };

export type DeleteAgentConfigurationMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  agentId: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteAgentConfigurationMutation = { readonly tenant?: { readonly zone?: { readonly deleteAgentConfiguration?: Void | null } | null } | null };

export type SaveAgentConfigurationMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  configuration: AgentConfigurationInput;
}>;


export type SaveAgentConfigurationMutation = { readonly tenant?: { readonly zone?: { readonly saveAgentConfiguration?: { readonly agentId: string, readonly conversationId?: string | null, readonly context?: { readonly dmsResources?: any | null, readonly instructions?: string | null, readonly knowledgeBaseFiles?: ReadonlyArray<{ readonly knowledgeBaseId: string, readonly s3Uri: string }> | null } | null } | null } | null } | null };

export type AgentConfigurationQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  agentId: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AgentConfigurationQuery = { readonly tenant?: { readonly zone?: { readonly agentConfiguration?: { readonly agentId: string, readonly conversationId?: string | null, readonly context?: { readonly dmsResources?: any | null, readonly instructions?: string | null, readonly knowledgeBaseFiles?: ReadonlyArray<{ readonly knowledgeBaseId: string, readonly s3Uri: string }> | null } | null } | null } | null } | null };

export type AgentKnowledgeBaseFilesQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  agentId: Scalars['String']['input'];
}>;


export type AgentKnowledgeBaseFilesQuery = { readonly tenant?: { readonly zone?: { readonly agentKnowledgeBaseFiles?: ReadonlyArray<{ readonly knowledgeBaseId: string, readonly s3Uri: string } | null> | null } | null } | null };

export type DeleteAgentChatConversationMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
}>;


export type DeleteAgentChatConversationMutation = { readonly tenant?: { readonly zone?: { readonly deleteAgentChatConversation?: Void | null } | null } | null };

export type PutAgentChatConversationMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  input: AgentChatConversationInput;
}>;


export type PutAgentChatConversationMutation = { readonly tenant?: { readonly zone?: { readonly putAgentChatConversation?: { readonly agentId: string, readonly createdAt?: any | null, readonly id: string, readonly name?: string | null, readonly ownerId: string, readonly sharedWith: ReadonlyArray<string>, readonly workspaceId?: string | null } | null } | null } | null };

export type AgentChatConversationsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  agentId: Scalars['String']['input'];
}>;


export type AgentChatConversationsQuery = { readonly tenant?: { readonly zone?: { readonly agentChatConversations?: ReadonlyArray<{ readonly id: string, readonly createdAt?: any | null, readonly name?: string | null, readonly agentId: string, readonly ownerId: string, readonly sharedWith: ReadonlyArray<string>, readonly workspaceId?: string | null }> | null } | null } | null };

export type OnAgentConversationPublishedSubscriptionVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  agentId: Scalars['String']['input'];
}>;


export type OnAgentConversationPublishedSubscription = { readonly onAgentConversationPublished?: { readonly agentId: string, readonly createdAt?: any | null, readonly id: string, readonly name?: string | null, readonly tenantId: string, readonly workspaceId?: string | null, readonly zoneId: string, readonly ownerId: string, readonly sharedWith: ReadonlyArray<string> } | null };

export type FragmentAgentChatMessageInfoFragment = { readonly type: string, readonly createdAt?: any | null, readonly payload?: any | null };

export type FragmentAgentChatMessageFragment = { readonly id: string, readonly role?: AgentMessageRole | null, readonly conversationId?: string | null, readonly createdAt?: any | null, readonly status?: AgentMessageStatus | null, readonly info?: ReadonlyArray<{ readonly type: string, readonly createdAt?: any | null, readonly payload?: any | null }> | null };

export type AskAgentMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  input: AgentChatMessageInput;
  conversationContext: AgentChatMessageConversationContextInput;
  knowledgeBaseRetrieval?: InputMaybe<AgentKnowledgeBaseRetrievalInput>;
}>;


export type AskAgentMutation = { readonly tenant?: { readonly zone?: { readonly askAgent?: Void | null } | null } | null };

export type RetryAgentMessageMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
}>;


export type RetryAgentMessageMutation = { readonly tenant?: { readonly zone?: { readonly retryAgentMessage?: Void | null } | null } | null };

export type AgentChatMessagesQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
}>;


export type AgentChatMessagesQuery = { readonly tenant?: { readonly zone?: { readonly agentChatMessages?: ReadonlyArray<{ readonly id: string, readonly role?: AgentMessageRole | null, readonly conversationId?: string | null, readonly createdAt?: any | null, readonly status?: AgentMessageStatus | null, readonly info?: ReadonlyArray<{ readonly type: string, readonly createdAt?: any | null, readonly payload?: any | null }> | null }> | null } | null } | null };

export type OnAgentMessageInfoPublishedSubscriptionVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
}>;


export type OnAgentMessageInfoPublishedSubscription = { readonly onAgentMessageInfoPublished?: { readonly conversationId: string, readonly messageId: string, readonly seq: number, readonly type: string, readonly createdAt?: any | null, readonly payload?: any | null, readonly tenantId: string, readonly zoneId: string } | null };

export type OnAgentMessagePublishedSubscriptionVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
}>;


export type OnAgentMessagePublishedSubscription = { readonly onAgentMessagePublished?: { readonly id: string, readonly role?: AgentMessageRole | null, readonly conversationId: string, readonly createdAt?: any | null, readonly status?: AgentMessageStatus | null, readonly tenantId: string, readonly zoneId: string } | null };

export type DeleteAgentChatWorkspaceMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type DeleteAgentChatWorkspaceMutation = { readonly tenant?: { readonly zone?: { readonly deleteAgentChatWorkspace?: Void | null } | null } | null };

export type PutAgentChatWorkspaceMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  input: AgentChatWorkspaceInput;
}>;


export type PutAgentChatWorkspaceMutation = { readonly tenant?: { readonly zone?: { readonly putAgentChatWorkspace?: { readonly id: string, readonly createdAt?: any | null, readonly name: string, readonly description?: string | null, readonly ownerId: string, readonly sharedWith: ReadonlyArray<string> } | null } | null } | null };

export type AgentChatWorkspaceQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type AgentChatWorkspaceQuery = { readonly tenant?: { readonly zone?: { readonly agentChatWorkspace?: { readonly id: string, readonly createdAt?: any | null, readonly name: string, readonly description?: string | null, readonly ownerId: string, readonly sharedWith: ReadonlyArray<string> } | null } | null } | null };

export type AgentChatWorkspacesQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
}>;


export type AgentChatWorkspacesQuery = { readonly tenant?: { readonly zone?: { readonly agentChatWorkspaces?: ReadonlyArray<{ readonly id: string, readonly createdAt?: any | null, readonly name: string, readonly description?: string | null, readonly ownerId: string, readonly sharedWith: ReadonlyArray<string> }> | null } | null } | null };

export type FragmentLinkDestinationFragment = { readonly navigationId?: string | null, readonly segmentId?: string | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null };

export type FragmentLinkFragment = { readonly goto?: { readonly navigationId?: string | null, readonly segmentId?: string | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null };

export type FragmentDmsEnumValueTypeFragment = { readonly enumId?: string | null, readonly isMultiselect?: boolean | null };

export type FragmentDmsFilesValueTypeFragment = { readonly isFile?: boolean | null };

export type FragmentDmsInlineEnumValueTypeFragment = { readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null }> | null };

export type FragmentDmsIntrinsicValueTypeFragment = { readonly intrinsic?: IntrinsicValueType | null };

export type FragmentDmsMultiReferenceValueTypeFragment = { readonly dimensionId?: string | null };

export type FragmentDmsReferenceValueTypeFragment = { readonly dimensionId?: string | null };

export type FragmentDmsStructureValueTypeFragment = { readonly structureId?: string | null };

type FragmentDmsValueTypeForAttribute_DmsEnumValueType_Fragment = { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null };

type FragmentDmsValueTypeForAttribute_DmsFilesValueType_Fragment = { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null };

type FragmentDmsValueTypeForAttribute_DmsIntrinsicValueType_Fragment = { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null };

type FragmentDmsValueTypeForAttribute_DmsReferenceValueType_Fragment = { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null };

type FragmentDmsValueTypeForAttribute_DmsStructureValueType_Fragment = { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null };

export type FragmentDmsValueTypeForAttributeFragment = FragmentDmsValueTypeForAttribute_DmsEnumValueType_Fragment | FragmentDmsValueTypeForAttribute_DmsFilesValueType_Fragment | FragmentDmsValueTypeForAttribute_DmsIntrinsicValueType_Fragment | FragmentDmsValueTypeForAttribute_DmsReferenceValueType_Fragment | FragmentDmsValueTypeForAttribute_DmsStructureValueType_Fragment;

type FragmentDmsValueType_DmsEnumValueType_Fragment = { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null };

type FragmentDmsValueType_DmsFilesValueType_Fragment = { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null };

type FragmentDmsValueType_DmsInlineEnumValueType_Fragment = { readonly __typename: 'DmsInlineEnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null }> | null };

type FragmentDmsValueType_DmsIntrinsicValueType_Fragment = { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null };

type FragmentDmsValueType_DmsMultiReferenceValueType_Fragment = { readonly __typename: 'DmsMultiReferenceValueType', readonly dimensionId?: string | null };

type FragmentDmsValueType_DmsReferenceValueType_Fragment = { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null };

type FragmentDmsValueType_DmsStructureValueType_Fragment = { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null };

export type FragmentDmsValueTypeFragment = FragmentDmsValueType_DmsEnumValueType_Fragment | FragmentDmsValueType_DmsFilesValueType_Fragment | FragmentDmsValueType_DmsInlineEnumValueType_Fragment | FragmentDmsValueType_DmsIntrinsicValueType_Fragment | FragmentDmsValueType_DmsMultiReferenceValueType_Fragment | FragmentDmsValueType_DmsReferenceValueType_Fragment | FragmentDmsValueType_DmsStructureValueType_Fragment;

export type FragmentVariableValueFragment = { readonly variable?: string | null, readonly value?: any | null };

export type FragmentVariableFragment = { readonly id?: string | null, readonly name?: string | null, readonly description?: string | null, readonly defaultValue?: any | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsInlineEnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null }> | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsMultiReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null };

export type FragmentDmsAttributeFragment = { readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly default?: any | null, readonly computation?: any | null, readonly isOptional?: boolean | null, readonly canBeOptional?: boolean | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null, readonly constraints?: { readonly acceptable?: ReadonlyArray<any | null> | null, readonly unacceptable?: ReadonlyArray<any | null> | null, readonly pattern?: string | null, readonly minLength?: number | null, readonly maxLength?: number | null, readonly max?: any | null, readonly min?: any | null } | null, readonly scoring?: { readonly default?: number | null, readonly lookup?: ReadonlyArray<{ readonly key?: string | null, readonly value?: number | null }> | null } | null };

export type FragmentDmsDimensionFragment = { readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly attributes?: ReadonlyArray<{ readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly default?: any | null, readonly computation?: any | null, readonly isOptional?: boolean | null, readonly canBeOptional?: boolean | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null, readonly constraints?: { readonly acceptable?: ReadonlyArray<any | null> | null, readonly unacceptable?: ReadonlyArray<any | null> | null, readonly pattern?: string | null, readonly minLength?: number | null, readonly maxLength?: number | null, readonly max?: any | null, readonly min?: any | null } | null, readonly scoring?: { readonly default?: number | null, readonly lookup?: ReadonlyArray<{ readonly key?: string | null, readonly value?: number | null }> | null } | null } | null> | null, readonly entities?: ReadonlyArray<{ readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly level?: number | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly parent?: { readonly id: string, readonly name?: string | null, readonly description?: string | null } | null, readonly child?: { readonly id: string, readonly name?: string | null, readonly description?: string | null } | null, readonly attributes?: ReadonlyArray<{ readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly default?: any | null, readonly computation?: any | null, readonly isOptional?: boolean | null, readonly canBeOptional?: boolean | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null, readonly constraints?: { readonly acceptable?: ReadonlyArray<any | null> | null, readonly unacceptable?: ReadonlyArray<any | null> | null, readonly pattern?: string | null, readonly minLength?: number | null, readonly maxLength?: number | null, readonly max?: any | null, readonly min?: any | null } | null, readonly scoring?: { readonly default?: number | null, readonly lookup?: ReadonlyArray<{ readonly key?: string | null, readonly value?: number | null }> | null } | null } | null> | null } | null> | null, readonly snapshots?: ReadonlyArray<{ readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly attributes?: ReadonlyArray<{ readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly default?: any | null, readonly computation?: any | null, readonly isOptional?: boolean | null, readonly canBeOptional?: boolean | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null, readonly constraints?: { readonly acceptable?: ReadonlyArray<any | null> | null, readonly unacceptable?: ReadonlyArray<any | null> | null, readonly pattern?: string | null, readonly minLength?: number | null, readonly maxLength?: number | null, readonly max?: any | null, readonly min?: any | null } | null, readonly scoring?: { readonly default?: number | null, readonly lookup?: ReadonlyArray<{ readonly key?: string | null, readonly value?: number | null }> | null } | null } | null> | null, readonly dimension?: { readonly id: string, readonly name?: string | null, readonly description?: string | null } | null } | null> | null };

export type FragmentDmsEntityFragment = { readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly level?: number | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly parent?: { readonly id: string, readonly name?: string | null, readonly description?: string | null } | null, readonly child?: { readonly id: string, readonly name?: string | null, readonly description?: string | null } | null, readonly attributes?: ReadonlyArray<{ readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly default?: any | null, readonly computation?: any | null, readonly isOptional?: boolean | null, readonly canBeOptional?: boolean | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null, readonly constraints?: { readonly acceptable?: ReadonlyArray<any | null> | null, readonly unacceptable?: ReadonlyArray<any | null> | null, readonly pattern?: string | null, readonly minLength?: number | null, readonly maxLength?: number | null, readonly max?: any | null, readonly min?: any | null } | null, readonly scoring?: { readonly default?: number | null, readonly lookup?: ReadonlyArray<{ readonly key?: string | null, readonly value?: number | null }> | null } | null } | null> | null };

export type FragmentDmsEnumFragment = { readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly entries?: ReadonlyArray<{ readonly id: string, readonly name?: string | null, readonly description?: string | null }> | null };

export type FragmentDmsSnapshotFragment = { readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly attributes?: ReadonlyArray<{ readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly default?: any | null, readonly computation?: any | null, readonly isOptional?: boolean | null, readonly canBeOptional?: boolean | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null, readonly constraints?: { readonly acceptable?: ReadonlyArray<any | null> | null, readonly unacceptable?: ReadonlyArray<any | null> | null, readonly pattern?: string | null, readonly minLength?: number | null, readonly maxLength?: number | null, readonly max?: any | null, readonly min?: any | null } | null, readonly scoring?: { readonly default?: number | null, readonly lookup?: ReadonlyArray<{ readonly key?: string | null, readonly value?: number | null }> | null } | null } | null> | null, readonly dimension?: { readonly id: string, readonly name?: string | null, readonly description?: string | null } | null };

export type FragmentFaFunctionCategorizationIdsFragment = { readonly category?: { readonly id: string } | null, readonly subcategory?: { readonly id: string } | null };

export type FragmentFaFunctionCategorizationFragment = { readonly category?: { readonly id: string, readonly code?: string | null, readonly name?: string | null, readonly type?: FaFunctionType | null } | null, readonly subcategory?: { readonly id: string, readonly code?: string | null, readonly name?: string | null, readonly isUtilityRelated?: boolean | null } | null };

export type FragmentFaFunctionCategoryFragment = { readonly id: string, readonly code?: string | null, readonly name?: string | null, readonly type?: FaFunctionType | null };

export type FragmentFaFunctionSubcategoryFragment = { readonly id: string, readonly code?: string | null, readonly name?: string | null, readonly isUtilityRelated?: boolean | null };

export type FragmentFlexibleIdentifierFragment = { readonly id?: string | null, readonly alias?: string | null };

export type FragmentDateWithUtcOffsetFragment = { readonly date?: any | null, readonly utcOffset?: number | null };

export type FragmentValueConstraintsFragment = { readonly acceptable?: ReadonlyArray<any | null> | null, readonly unacceptable?: ReadonlyArray<any | null> | null, readonly pattern?: string | null, readonly minLength?: number | null, readonly maxLength?: number | null, readonly max?: any | null, readonly min?: any | null };

export type FragmentEnumValueTypeFragment = { readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null };

type FragmentStructureValueType_StructureValueTypeList_Fragment = { readonly __typename: 'StructureValueTypeList' };

type FragmentStructureValueType_StructureValueTypeObject_Fragment = { readonly __typename: 'StructureValueTypeObject' };

type FragmentStructureValueType_StructureValueTypeTuple_Fragment = { readonly __typename: 'StructureValueTypeTuple' };

export type FragmentStructureValueTypeFragment = FragmentStructureValueType_StructureValueTypeList_Fragment | FragmentStructureValueType_StructureValueTypeObject_Fragment | FragmentStructureValueType_StructureValueTypeTuple_Fragment;

type FragmentValueType_EnumValueType_Fragment = { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null };

type FragmentValueType_IntrinsicValueTypeWrapper_Fragment = { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null };

type FragmentValueType_StructureValueTypeList_Fragment = { readonly __typename: 'StructureValueTypeList' };

type FragmentValueType_StructureValueTypeObject_Fragment = { readonly __typename: 'StructureValueTypeObject' };

type FragmentValueType_StructureValueTypeTuple_Fragment = { readonly __typename: 'StructureValueTypeTuple' };

export type FragmentValueTypeFragment = FragmentValueType_EnumValueType_Fragment | FragmentValueType_IntrinsicValueTypeWrapper_Fragment | FragmentValueType_StructureValueTypeList_Fragment | FragmentValueType_StructureValueTypeObject_Fragment | FragmentValueType_StructureValueTypeTuple_Fragment;

export type FragmentValueWithInfoFragment = { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null };

export type QueryRecordsDataQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  query: Scalars['AWSJSON']['input'];
}>;


export type QueryRecordsDataQuery = { readonly tenant?: { readonly zone?: { readonly data?: any | null } | null } | null };

export type DeleteZoneDataMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  deletion: DataDeletion;
}>;


export type DeleteZoneDataMutation = { readonly tenant?: { readonly zone?: { readonly deleteData?: boolean | null } | null } | null };

export type PutZoneDataMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  insertion: DataInsertion;
}>;


export type PutZoneDataMutation = { readonly tenant?: { readonly zone?: { readonly putData?: boolean | null } | null } | null };

export type QueryDataQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  query: Scalars['AWSJSON']['input'];
}>;


export type QueryDataQuery = { readonly tenant?: { readonly zone?: { readonly data?: any | null } | null } | null };

export type DmsModelsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
}>;


export type DmsModelsQuery = { readonly tenant?: { readonly zone?: { readonly models?: ReadonlyArray<{ readonly __typename: 'DmsAttribute', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly default?: any | null, readonly computation?: any | null, readonly isOptional?: boolean | null, readonly canBeOptional?: boolean | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null, readonly constraints?: { readonly acceptable?: ReadonlyArray<any | null> | null, readonly unacceptable?: ReadonlyArray<any | null> | null, readonly pattern?: string | null, readonly minLength?: number | null, readonly maxLength?: number | null, readonly max?: any | null, readonly min?: any | null } | null, readonly scoring?: { readonly default?: number | null, readonly lookup?: ReadonlyArray<{ readonly key?: string | null, readonly value?: number | null }> | null } | null } | { readonly __typename: 'DmsDimension', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly attributes?: ReadonlyArray<{ readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly default?: any | null, readonly computation?: any | null, readonly isOptional?: boolean | null, readonly canBeOptional?: boolean | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null, readonly constraints?: { readonly acceptable?: ReadonlyArray<any | null> | null, readonly unacceptable?: ReadonlyArray<any | null> | null, readonly pattern?: string | null, readonly minLength?: number | null, readonly maxLength?: number | null, readonly max?: any | null, readonly min?: any | null } | null, readonly scoring?: { readonly default?: number | null, readonly lookup?: ReadonlyArray<{ readonly key?: string | null, readonly value?: number | null }> | null } | null } | null> | null, readonly entities?: ReadonlyArray<{ readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly level?: number | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly parent?: { readonly id: string, readonly name?: string | null, readonly description?: string | null } | null, readonly child?: { readonly id: string, readonly name?: string | null, readonly description?: string | null } | null, readonly attributes?: ReadonlyArray<{ readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly default?: any | null, readonly computation?: any | null, readonly isOptional?: boolean | null, readonly canBeOptional?: boolean | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null, readonly constraints?: { readonly acceptable?: ReadonlyArray<any | null> | null, readonly unacceptable?: ReadonlyArray<any | null> | null, readonly pattern?: string | null, readonly minLength?: number | null, readonly maxLength?: number | null, readonly max?: any | null, readonly min?: any | null } | null, readonly scoring?: { readonly default?: number | null, readonly lookup?: ReadonlyArray<{ readonly key?: string | null, readonly value?: number | null }> | null } | null } | null> | null } | null> | null, readonly snapshots?: ReadonlyArray<{ readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly attributes?: ReadonlyArray<{ readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly default?: any | null, readonly computation?: any | null, readonly isOptional?: boolean | null, readonly canBeOptional?: boolean | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null, readonly constraints?: { readonly acceptable?: ReadonlyArray<any | null> | null, readonly unacceptable?: ReadonlyArray<any | null> | null, readonly pattern?: string | null, readonly minLength?: number | null, readonly maxLength?: number | null, readonly max?: any | null, readonly min?: any | null } | null, readonly scoring?: { readonly default?: number | null, readonly lookup?: ReadonlyArray<{ readonly key?: string | null, readonly value?: number | null }> | null } | null } | null> | null, readonly dimension?: { readonly id: string, readonly name?: string | null, readonly description?: string | null } | null } | null> | null } | { readonly __typename: 'DmsEntity', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly level?: number | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly parent?: { readonly id: string, readonly name?: string | null, readonly description?: string | null } | null, readonly child?: { readonly id: string, readonly name?: string | null, readonly description?: string | null } | null, readonly attributes?: ReadonlyArray<{ readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly default?: any | null, readonly computation?: any | null, readonly isOptional?: boolean | null, readonly canBeOptional?: boolean | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null, readonly constraints?: { readonly acceptable?: ReadonlyArray<any | null> | null, readonly unacceptable?: ReadonlyArray<any | null> | null, readonly pattern?: string | null, readonly minLength?: number | null, readonly maxLength?: number | null, readonly max?: any | null, readonly min?: any | null } | null, readonly scoring?: { readonly default?: number | null, readonly lookup?: ReadonlyArray<{ readonly key?: string | null, readonly value?: number | null }> | null } | null } | null> | null } | { readonly __typename: 'DmsEnum', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly entries?: ReadonlyArray<{ readonly id: string, readonly name?: string | null, readonly description?: string | null }> | null } | { readonly __typename: 'DmsPurpose' } | { readonly __typename: 'DmsSnapshot', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly attributes?: ReadonlyArray<{ readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly default?: any | null, readonly computation?: any | null, readonly isOptional?: boolean | null, readonly canBeOptional?: boolean | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null, readonly constraints?: { readonly acceptable?: ReadonlyArray<any | null> | null, readonly unacceptable?: ReadonlyArray<any | null> | null, readonly pattern?: string | null, readonly minLength?: number | null, readonly maxLength?: number | null, readonly max?: any | null, readonly min?: any | null } | null, readonly scoring?: { readonly default?: number | null, readonly lookup?: ReadonlyArray<{ readonly key?: string | null, readonly value?: number | null }> | null } | null } | null> | null, readonly dimension?: { readonly id: string, readonly name?: string | null, readonly description?: string | null } | null } | { readonly __typename: 'DmsStructure' } | null> | null } | null } | null };

export type UploadRequestQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  extension: Scalars['String']['input'];
}>;


export type UploadRequestQuery = { readonly tenant?: { readonly zone?: { readonly dataUploadRequest?: { readonly url?: any | null, readonly fields?: ReadonlyArray<{ readonly id?: string | null, readonly value?: string | null } | null> | null } | null } | null } | null };

export type DataDownloadRequestQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  fileInput: FileInput;
}>;


export type DataDownloadRequestQuery = { readonly tenant?: { readonly zone?: { readonly dataDownloadRequest?: string | null } | null } | null };

export type FilesQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
}>;


export type FilesQuery = { readonly tenant?: { readonly zone?: { readonly files?: ReadonlyArray<{ readonly appId?: string | null, readonly extension?: string | null, readonly id: string, readonly isPrivate?: boolean | null, readonly qualifier?: string | null, readonly scenarioId?: string | null }> | null } | null } | null };

export type DataUploadRequest2QueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  fileInput: FileInput;
}>;


export type DataUploadRequest2Query = { readonly tenant?: { readonly zone?: { readonly dataUploadRequest2?: { readonly url?: any | null, readonly fields?: ReadonlyArray<{ readonly id?: string | null, readonly value?: string | null } | null> | null } | null } | null } | null };

export type FragmentIntegrationConnectorDefinitionFragment = { readonly id: string, readonly name: string, readonly imports: ReadonlyArray<{ readonly api: { readonly path: string, readonly recordsPath?: string | null, readonly responseType: IntgApiResponseType, readonly pagination?: any | null, readonly query?: ReadonlyArray<{ readonly name: string, readonly value: string }> | null }, readonly mapping: { readonly modelId: string, readonly fields: ReadonlyArray<{ readonly source: string, readonly target: string, readonly reference?: { readonly entityId: string } | null }> } }> };

export type FragmentIntegrationConnectorFragment = { readonly id: string, readonly name: string, readonly definitionId: string, readonly baseUrl: string, readonly lastRun?: { readonly id: string, readonly startedAt: any, readonly completedAt?: any | null, readonly error?: string | null, readonly imports: ReadonlyArray<{ readonly path: string, readonly status: string, readonly error?: string | null }> } | null };

export type CreateIntegrationConnectorDefinitionMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  input: IntgConnectorDefinitionInput;
}>;


export type CreateIntegrationConnectorDefinitionMutation = { readonly tenant?: { readonly zone?: { readonly createIntgConnectorDefinition: { readonly id: string, readonly name: string, readonly imports: ReadonlyArray<{ readonly api: { readonly path: string, readonly recordsPath?: string | null, readonly responseType: IntgApiResponseType, readonly pagination?: any | null, readonly query?: ReadonlyArray<{ readonly name: string, readonly value: string }> | null }, readonly mapping: { readonly modelId: string, readonly fields: ReadonlyArray<{ readonly source: string, readonly target: string, readonly reference?: { readonly entityId: string } | null }> } }> } } | null } | null };

export type CreateIntegrationConnectorMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  input: IntgConnectorInput;
  apiKey: Scalars['String']['input'];
}>;


export type CreateIntegrationConnectorMutation = { readonly tenant?: { readonly zone?: { readonly createIntgConnector: { readonly id: string, readonly name: string, readonly definitionId: string, readonly baseUrl: string, readonly lastRun?: { readonly id: string, readonly startedAt: any, readonly completedAt?: any | null, readonly error?: string | null, readonly imports: ReadonlyArray<{ readonly path: string, readonly status: string, readonly error?: string | null }> } | null } } | null } | null };

export type DeleteIntegrationConnectorDefinitionMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type DeleteIntegrationConnectorDefinitionMutation = { readonly tenant?: { readonly zone?: { readonly deleteIntgConnectorDefinition?: Void | null } | null } | null };

export type DeleteIntegrationConnectorMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type DeleteIntegrationConnectorMutation = { readonly tenant?: { readonly zone?: { readonly deleteIntgConnector?: Void | null } | null } | null };

export type RunIntegrationConnectorMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  connectorId: Scalars['ID']['input'];
  truncateModelIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type RunIntegrationConnectorMutation = { readonly tenant?: { readonly zone?: { readonly runIntegration: boolean } | null } | null };

export type UpdateIntegrationConnectorDefinitionMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  updates: IntgConnectorDefinitionUpdates;
}>;


export type UpdateIntegrationConnectorDefinitionMutation = { readonly tenant?: { readonly zone?: { readonly updateIntgConnectorDefinition: { readonly id: string, readonly name: string, readonly imports: ReadonlyArray<{ readonly api: { readonly path: string, readonly recordsPath?: string | null, readonly responseType: IntgApiResponseType, readonly pagination?: any | null, readonly query?: ReadonlyArray<{ readonly name: string, readonly value: string }> | null }, readonly mapping: { readonly modelId: string, readonly fields: ReadonlyArray<{ readonly source: string, readonly target: string, readonly reference?: { readonly entityId: string } | null }> } }> } } | null } | null };

export type UpdateIntegrationConnectorMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  updates: IntgConnectorUpdates;
}>;


export type UpdateIntegrationConnectorMutation = { readonly tenant?: { readonly zone?: { readonly updateIntgConnector: { readonly id: string, readonly name: string, readonly definitionId: string, readonly baseUrl: string, readonly lastRun?: { readonly id: string, readonly startedAt: any, readonly completedAt?: any | null, readonly error?: string | null, readonly imports: ReadonlyArray<{ readonly path: string, readonly status: string, readonly error?: string | null }> } | null } } | null } | null };

export type IntegrationConnectorDefinitionQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type IntegrationConnectorDefinitionQuery = { readonly tenant?: { readonly zone?: { readonly intgConnectorDefinition: { readonly id: string, readonly name: string, readonly imports: ReadonlyArray<{ readonly api: { readonly path: string, readonly recordsPath?: string | null, readonly responseType: IntgApiResponseType, readonly pagination?: any | null, readonly query?: ReadonlyArray<{ readonly name: string, readonly value: string }> | null }, readonly mapping: { readonly modelId: string, readonly fields: ReadonlyArray<{ readonly source: string, readonly target: string, readonly reference?: { readonly entityId: string } | null }> } }> } } | null } | null };

export type IntegrationConnectorDefinitionsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
}>;


export type IntegrationConnectorDefinitionsQuery = { readonly tenant?: { readonly zone?: { readonly intgConnectorDefinitions: ReadonlyArray<{ readonly id: string, readonly name: string, readonly imports: ReadonlyArray<{ readonly api: { readonly path: string, readonly recordsPath?: string | null, readonly responseType: IntgApiResponseType, readonly pagination?: any | null, readonly query?: ReadonlyArray<{ readonly name: string, readonly value: string }> | null }, readonly mapping: { readonly modelId: string, readonly fields: ReadonlyArray<{ readonly source: string, readonly target: string, readonly reference?: { readonly entityId: string } | null }> } }> }> } | null } | null };

export type IntegrationConnectorQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type IntegrationConnectorQuery = { readonly tenant?: { readonly zone?: { readonly intgConnector: { readonly id: string, readonly name: string, readonly definitionId: string, readonly baseUrl: string, readonly lastRun?: { readonly id: string, readonly startedAt: any, readonly completedAt?: any | null, readonly error?: string | null, readonly imports: ReadonlyArray<{ readonly path: string, readonly status: string, readonly error?: string | null }> } | null } } | null } | null };

export type IntegrationConnectorsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
}>;


export type IntegrationConnectorsQuery = { readonly tenant?: { readonly zone?: { readonly intgConnectors: ReadonlyArray<{ readonly id: string, readonly name: string, readonly definitionId: string, readonly baseUrl: string, readonly lastRun?: { readonly id: string, readonly startedAt: any, readonly completedAt?: any | null, readonly error?: string | null, readonly imports: ReadonlyArray<{ readonly path: string, readonly status: string, readonly error?: string | null }> } | null }> } | null } | null };

export type OnIntegrationConnectorRunPublishedSubscriptionVariables = Exact<{
  connectorId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
}>;


export type OnIntegrationConnectorRunPublishedSubscription = { readonly onIntgConnectorRunPublished?: { readonly connectorId: string, readonly run: { readonly id: string, readonly startedAt: any, readonly completedAt?: any | null, readonly error?: string | null, readonly imports: ReadonlyArray<{ readonly path: string, readonly status: string, readonly error?: string | null }> } } | null };

export type FragmentMeAgentForUserFragment = { readonly id: string, readonly access: number, readonly pageContext?: { readonly pageAliases?: ReadonlyArray<string> | null, readonly isForNonPrebuiltPages?: boolean | null } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { readonly me: { readonly id: string, readonly email?: any | null, readonly employeeId?: string | null, readonly firstName?: string | null, readonly isPlatformAdmin?: boolean | null, readonly isTenant?: boolean | null, readonly lastName?: string | null, readonly jobTitle?: string | null, readonly phoneNumber?: any | null, readonly tags?: ReadonlyArray<{ readonly key?: string | null, readonly value?: any | null } | null> | null, readonly tenants?: ReadonlyArray<{ readonly access?: number | null, readonly info: { readonly id: string, readonly alias?: string | null, readonly code?: string | null, readonly name?: string | null, readonly color?: string | null, readonly createdBy?: string | null, readonly monthlyCreditLimit?: number | null }, readonly agents?: ReadonlyArray<{ readonly id: string, readonly access: number, readonly pageContext?: { readonly pageAliases?: ReadonlyArray<string> | null, readonly isForNonPrebuiltPages?: boolean | null } | null }> | null, readonly zones?: ReadonlyArray<{ readonly access?: number | null, readonly info: { readonly id: string, readonly alias?: string | null, readonly code?: string | null, readonly name?: string | null, readonly description?: string | null, readonly createdBy?: string | null }, readonly agents?: ReadonlyArray<{ readonly id: string, readonly access: number, readonly pageContext?: { readonly pageAliases?: ReadonlyArray<string> | null, readonly isForNonPrebuiltPages?: boolean | null } | null }> | null } | null> | null } | null> | null } };

export type QueryEmployeeDataQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  query: Scalars['AWSJSON']['input'];
}>;


export type QueryEmployeeDataQuery = { readonly tenant?: { readonly zone?: { readonly data?: any | null } | null } | null };

export type FragmentMeSiblingUserFragment = { readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null };

export type MeUsersInAppQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
}>;


export type MeUsersInAppQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly users?: { readonly items: ReadonlyArray<{ readonly info?: { readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null } | null> } | null } | null } | null } | null };

export type MeUsersInScenarioQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
}>;


export type MeUsersInScenarioQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly users?: { readonly items: ReadonlyArray<{ readonly info?: { readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null } | null> } | null } | null } | null } | null } | null };

export type MeUsersInZoneQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
}>;


export type MeUsersInZoneQuery = { readonly tenant?: { readonly zone?: { readonly users?: { readonly items: ReadonlyArray<{ readonly info?: { readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null } | null> } | null } | null } | null };

export type MeZoneAppsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
}>;


export type MeZoneAppsQuery = { readonly me: { readonly tenant?: { readonly zone?: { readonly apps?: ReadonlyArray<{ readonly access?: number | null, readonly info: { readonly id: string, readonly alias?: string | null, readonly name?: string | null, readonly icon?: string | null, readonly description?: string | null, readonly createdBy?: string | null, readonly supportsScenarios?: boolean | null, readonly supportsFunctionalityConfiguration?: boolean | null, readonly scenarioVariables?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null, readonly defaultValue?: any | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsInlineEnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null }> | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsMultiReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null } | null> | null, readonly sessionVariables?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null, readonly defaultValue?: any | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsInlineEnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null }> | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsMultiReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null } | null> | null }, readonly pages?: ReadonlyArray<{ readonly id?: string | null, readonly alias?: string | null, readonly pageId?: string | null, readonly name?: string | null, readonly description?: string | null, readonly display?: { readonly isMain?: boolean | null, readonly position?: number | null } | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null> | null, readonly scenarios?: ReadonlyArray<{ readonly access?: number | null, readonly info: { readonly id: string, readonly alias?: string | null, readonly name?: string | null, readonly description?: string | null, readonly createdBy?: string | null, readonly visibility?: ScenarioVisibility | null, readonly period?: { readonly startDate?: any | null, readonly endDate?: any | null } | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } } | null> | null, readonly agents?: ReadonlyArray<{ readonly id: string, readonly access: number, readonly pageContext?: { readonly pageAliases?: ReadonlyArray<string> | null, readonly isForNonPrebuiltPages?: boolean | null } | null }> | null } | null> | null } | null } | null } };

export type FragmentMosaicActionFragment = { readonly id: string, readonly alias?: string | null, readonly name?: string | null, readonly query?: any | null, readonly description?: string | null };

export type FragmentMosaicActionExecutionResultFragment = { readonly alias?: string | null, readonly id?: string | null, readonly executedInUi?: ReadonlyArray<{ readonly __typename: 'MosaicUiModalActionRendering', readonly widget?: { readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null } | { readonly __typename: 'MosaicUiNavigateActionRendering', readonly link?: { readonly goto?: { readonly navigationId?: string | null, readonly segmentId?: string | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null } | null } | { readonly __typename: 'MosaicUiOpenAssistantActionRendering', readonly agentId?: string | null, readonly records?: ReadonlyArray<{ readonly modelId: string, readonly recordId: string } | null> | null } | { readonly __typename: 'MosaicUiSetVariablesActionRendering', readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | { readonly __typename: 'MosaicUiSlideoutActionRendering', readonly widget?: { readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null } | null> | null };

type FragmentMosaicUiActionRendering_MosaicUiModalActionRendering_Fragment = { readonly __typename: 'MosaicUiModalActionRendering', readonly widget?: { readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null };

type FragmentMosaicUiActionRendering_MosaicUiNavigateActionRendering_Fragment = { readonly __typename: 'MosaicUiNavigateActionRendering', readonly link?: { readonly goto?: { readonly navigationId?: string | null, readonly segmentId?: string | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null } | null };

type FragmentMosaicUiActionRendering_MosaicUiOpenAssistantActionRendering_Fragment = { readonly __typename: 'MosaicUiOpenAssistantActionRendering', readonly agentId?: string | null, readonly records?: ReadonlyArray<{ readonly modelId: string, readonly recordId: string } | null> | null };

type FragmentMosaicUiActionRendering_MosaicUiSetVariablesActionRendering_Fragment = { readonly __typename: 'MosaicUiSetVariablesActionRendering', readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null };

type FragmentMosaicUiActionRendering_MosaicUiSlideoutActionRendering_Fragment = { readonly __typename: 'MosaicUiSlideoutActionRendering', readonly widget?: { readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null };

export type FragmentMosaicUiActionRenderingFragment = FragmentMosaicUiActionRendering_MosaicUiModalActionRendering_Fragment | FragmentMosaicUiActionRendering_MosaicUiNavigateActionRendering_Fragment | FragmentMosaicUiActionRendering_MosaicUiOpenAssistantActionRendering_Fragment | FragmentMosaicUiActionRendering_MosaicUiSetVariablesActionRendering_Fragment | FragmentMosaicUiActionRendering_MosaicUiSlideoutActionRendering_Fragment;

export type FragmentMosaicUiModalActionRenderingFragment = { readonly widget?: { readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null };

export type FragmentMosaicUiNavigateActionRenderingFragment = { readonly link?: { readonly goto?: { readonly navigationId?: string | null, readonly segmentId?: string | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null } | null };

export type FragmentMosaicUiOpenAssistantActionRenderingFragment = { readonly agentId?: string | null, readonly records?: ReadonlyArray<{ readonly modelId: string, readonly recordId: string } | null> | null };

export type FragmentMosaicUiSetVariablesActionRenderingFragment = { readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null };

export type FragmentMosaicUiSlideoutActionRenderingFragment = { readonly widget?: { readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null };

export type CreateMosaicActionMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  input: MosaicActionInput;
}>;


export type CreateMosaicActionMutation = { readonly tenant?: { readonly zone?: { readonly mosaicDev?: { readonly createAction?: boolean | null } | null } | null } | null };

export type DeleteMosaicActionMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  actionIdentifier: FlexibleIdentifierInput;
}>;


export type DeleteMosaicActionMutation = { readonly tenant?: { readonly zone?: { readonly mosaicDev?: { readonly deleteAction?: boolean | null } | null } | null } | null };

export type TestMosaicActionRenderingMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  actionRendering: Scalars['AWSJSON']['input'];
}>;


export type TestMosaicActionRenderingMutation = { readonly tenant?: { readonly zone?: { readonly mosaicDev?: { readonly testActionRendering?: ReadonlyArray<{ readonly __typename: 'MosaicUiModalActionRendering', readonly widget?: { readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null } | { readonly __typename: 'MosaicUiNavigateActionRendering', readonly link?: { readonly goto?: { readonly navigationId?: string | null, readonly segmentId?: string | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null } | null } | { readonly __typename: 'MosaicUiOpenAssistantActionRendering', readonly agentId?: string | null, readonly records?: ReadonlyArray<{ readonly modelId: string, readonly recordId: string } | null> | null } | { readonly __typename: 'MosaicUiSetVariablesActionRendering', readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | { readonly __typename: 'MosaicUiSlideoutActionRendering', readonly widget?: { readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null } | null> | null } | null } | null } | null };

export type TestMosaicActionMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  actionIdentifier: FlexibleIdentifierInput;
}>;


export type TestMosaicActionMutation = { readonly tenant?: { readonly zone?: { readonly mosaicDev?: { readonly testAction?: ReadonlyArray<{ readonly __typename: 'MosaicUiModalActionRendering', readonly widget?: { readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null } | { readonly __typename: 'MosaicUiNavigateActionRendering', readonly link?: { readonly goto?: { readonly navigationId?: string | null, readonly segmentId?: string | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null } | null } | { readonly __typename: 'MosaicUiOpenAssistantActionRendering', readonly agentId?: string | null, readonly records?: ReadonlyArray<{ readonly modelId: string, readonly recordId: string } | null> | null } | { readonly __typename: 'MosaicUiSetVariablesActionRendering', readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | { readonly __typename: 'MosaicUiSlideoutActionRendering', readonly widget?: { readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null } | null> | null } | null } | null } | null };

export type UpdateMosaicActionMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  actionIdentifier: FlexibleIdentifierInput;
  updates: MosaicActionUpdates;
}>;


export type UpdateMosaicActionMutation = { readonly tenant?: { readonly zone?: { readonly mosaicDev?: { readonly updateAction?: boolean | null } | null } | null } | null };

export type MosaicActionQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  actionIdentifier: FlexibleIdentifierInput;
}>;


export type MosaicActionQuery = { readonly tenant?: { readonly zone?: { readonly mosaicDev?: { readonly action?: { readonly id: string, readonly alias?: string | null, readonly name?: string | null, readonly query?: any | null, readonly description?: string | null } | null } | null } | null } | null };

export type MosaicActionsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
}>;


export type MosaicActionsQuery = { readonly tenant?: { readonly zone?: { readonly mosaicDev?: { readonly actions?: ReadonlyArray<{ readonly id: string, readonly alias?: string | null, readonly name?: string | null, readonly query?: any | null, readonly description?: string | null } | null> | null } | null } | null } | null };

export type GenerateMosaicPageMutationVariables = Exact<{
  prompt: Scalars['String']['input'];
  zoneId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  data: Scalars['String']['input'];
}>;


export type GenerateMosaicPageMutation = { readonly tenant?: { readonly zone?: { readonly mosaicDev?: { readonly generateAiPage?: Void | null } | null } | null } | null };

export type FragmentMosaicPageWidgetRenderingFragment = { readonly alias?: string | null, readonly id?: string | null, readonly payload?: any | null };

export type FragmentMosaicPageForDevFragment = { readonly id: string, readonly alias?: string | null, readonly name?: string | null, readonly description?: string | null, readonly query?: any | null, readonly content?: any | null, readonly variables?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null, readonly defaultValue?: any | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsInlineEnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null }> | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsMultiReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null } | null> | null };

export type CreateMosaicPageForDevMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  input: MosaicPageForDevInput;
}>;


export type CreateMosaicPageForDevMutation = { readonly tenant?: { readonly zone?: { readonly mosaicDev?: { readonly createPage?: boolean | null } | null } | null } | null };

export type DeleteMosaicPageForDevMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  identifier: FlexibleIdentifierInput;
}>;


export type DeleteMosaicPageForDevMutation = { readonly tenant?: { readonly zone?: { readonly mosaicDev?: { readonly deletePage?: boolean | null } | null } | null } | null };

export type UpdateMosaicPageForDevMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  identifier: FlexibleIdentifierInput;
  updates: MosaicPageForDevUpdates;
}>;


export type UpdateMosaicPageForDevMutation = { readonly tenant?: { readonly zone?: { readonly mosaicDev?: { readonly updatePage?: boolean | null } | null } | null } | null };

export type MosaicPageWidgetsPreviewQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  widgetIdentifier: FlexibleIdentifierInput;
}>;


export type MosaicPageWidgetsPreviewQuery = { readonly tenant?: { readonly zone?: { readonly mosaicDev?: { readonly widgetPreview?: { readonly alias?: string | null, readonly id?: string | null, readonly payload?: any | null } | null } | null } | null } | null };

export type MosaicPageForDevQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  identifier: FlexibleIdentifierInput;
}>;


export type MosaicPageForDevQuery = { readonly tenant?: { readonly zone?: { readonly mosaicDev?: { readonly page?: { readonly id: string, readonly alias?: string | null, readonly name?: string | null, readonly description?: string | null, readonly query?: any | null, readonly content?: any | null, readonly variables?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null, readonly defaultValue?: any | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsInlineEnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null }> | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsMultiReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null } | null> | null } | null } | null } | null } | null };

export type MosaicPagesForDevQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
}>;


export type MosaicPagesForDevQuery = { readonly tenant?: { readonly zone?: { readonly mosaicDev?: { readonly pages?: ReadonlyArray<{ readonly id: string, readonly alias?: string | null, readonly name?: string | null, readonly description?: string | null, readonly query?: any | null, readonly content?: any | null, readonly variables?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null, readonly defaultValue?: any | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsInlineEnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null }> | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsMultiReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null } | null> | null } | null> | null } | null } | null } | null };

export type FragmentMosaicWidgetRefFragment = { readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null };

export type FragmentMosaicWidgetRenderingFragment = { readonly alias?: string | null, readonly id?: string | null, readonly payload?: any | null };

export type FragmentMosaicWidgetFragment = { readonly id: string, readonly alias?: string | null, readonly name?: string | null, readonly query?: any | null, readonly description?: string | null, readonly variables?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null, readonly defaultValue?: any | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsInlineEnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null }> | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsMultiReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null } | null> | null };

export type CreateMosaicWidgetMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  input: MosaicWidgetInput;
}>;


export type CreateMosaicWidgetMutation = { readonly tenant?: { readonly zone?: { readonly mosaicDev?: { readonly createWidget?: boolean | null } | null } | null } | null };

export type DeleteMosaicWidgetMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  widgetIdentifier: FlexibleIdentifierInput;
}>;


export type DeleteMosaicWidgetMutation = { readonly tenant?: { readonly zone?: { readonly mosaicDev?: { readonly deleteWidget?: boolean | null } | null } | null } | null };

export type UpdateMosaicWidgetMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  widgetIdentifier: FlexibleIdentifierInput;
  updates: MosaicWidgetUpdates;
}>;


export type UpdateMosaicWidgetMutation = { readonly tenant?: { readonly zone?: { readonly mosaicDev?: { readonly updateWidget?: boolean | null } | null } | null } | null };

export type MosaicWidgetPreviewQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  widgetIdentifier: FlexibleIdentifierInput;
}>;


export type MosaicWidgetPreviewQuery = { readonly tenant?: { readonly zone?: { readonly mosaicDev?: { readonly widgetPreview?: { readonly alias?: string | null, readonly id?: string | null, readonly payload?: any | null } | null } | null } | null } | null };

export type MosaicWidgetQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  widgetIdentifier: FlexibleIdentifierInput;
}>;


export type MosaicWidgetQuery = { readonly tenant?: { readonly zone?: { readonly mosaicDev?: { readonly widget?: { readonly id: string, readonly alias?: string | null, readonly name?: string | null, readonly query?: any | null, readonly description?: string | null, readonly variables?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null, readonly defaultValue?: any | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsInlineEnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null }> | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsMultiReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null } | null> | null } | null } | null } | null } | null };

export type MosaicWidgetsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
}>;


export type MosaicWidgetsQuery = { readonly tenant?: { readonly zone?: { readonly mosaicDev?: { readonly widgets?: ReadonlyArray<{ readonly id: string, readonly alias?: string | null, readonly name?: string | null, readonly query?: any | null, readonly description?: string | null, readonly variables?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null, readonly defaultValue?: any | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsInlineEnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null }> | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsMultiReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null } | null> | null } | null> | null } | null } | null } | null };

export type FragmentBreadcrumbFragment = { readonly name?: string | null, readonly goto?: { readonly navigationId?: string | null, readonly segmentId?: string | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null };

export type FragmentMosaicWidgetReferenceFragment = { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null };

export type FragmentMosaicPageLayoutListElementReferenceFragment = { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null };

type FragmentMosaicLayoutElementReference_MosaicPageLayoutListElementReference_Fragment = { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null };

type FragmentMosaicLayoutElementReference_MosaicWidgetReference_Fragment = { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null };

export type FragmentMosaicLayoutElementReferenceFragment = FragmentMosaicLayoutElementReference_MosaicPageLayoutListElementReference_Fragment | FragmentMosaicLayoutElementReference_MosaicWidgetReference_Fragment;

export type FragmentMosaicColumnElementFragment = { readonly height?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null };

export type FragmentMosaicRowElementFragment = { readonly span?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null };

export type FragmentMosaicPageLayoutFragment = { readonly root?: { readonly elements?: ReadonlyArray<{ readonly height?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null, readonly columns?: ReadonlyArray<{ readonly elements?: ReadonlyArray<{ readonly height?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null> | null, readonly rows?: ReadonlyArray<{ readonly elements?: ReadonlyArray<{ readonly span?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null> | null };

export type FragmentMosaicPageUnsegmentedContentFragment = { readonly __typename: 'MosaicPageUnsegmentedContent', readonly layout?: { readonly root?: { readonly elements?: ReadonlyArray<{ readonly height?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null, readonly columns?: ReadonlyArray<{ readonly elements?: ReadonlyArray<{ readonly height?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null> | null, readonly rows?: ReadonlyArray<{ readonly elements?: ReadonlyArray<{ readonly span?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null> | null } | null };

export type FragmentMosaicPageSegmentFragment = { readonly __typename: 'MosaicPageSegment', readonly alias?: string | null, readonly name?: string | null, readonly hasQuery?: boolean | null, readonly layout?: { readonly root?: { readonly elements?: ReadonlyArray<{ readonly height?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null, readonly columns?: ReadonlyArray<{ readonly elements?: ReadonlyArray<{ readonly height?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null> | null, readonly rows?: ReadonlyArray<{ readonly elements?: ReadonlyArray<{ readonly span?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null> | null } | null };

export type FragmentMosaicPageSegmentedContentFragment = { readonly __typename: 'MosaicPageSegmentedContent', readonly navigator?: MosaicPageSegmentNavigator | null, readonly segments?: ReadonlyArray<{ readonly __typename: 'MosaicPageSegment', readonly alias?: string | null, readonly name?: string | null, readonly hasQuery?: boolean | null, readonly layout?: { readonly root?: { readonly elements?: ReadonlyArray<{ readonly height?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null, readonly columns?: ReadonlyArray<{ readonly elements?: ReadonlyArray<{ readonly height?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null> | null, readonly rows?: ReadonlyArray<{ readonly elements?: ReadonlyArray<{ readonly span?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null> | null } | null } | null> | null };

type FragmentMosaicPageContent_MosaicPageSegmentedContent_Fragment = { readonly __typename: 'MosaicPageSegmentedContent', readonly navigator?: MosaicPageSegmentNavigator | null, readonly segments?: ReadonlyArray<{ readonly __typename: 'MosaicPageSegment', readonly alias?: string | null, readonly name?: string | null, readonly hasQuery?: boolean | null, readonly layout?: { readonly root?: { readonly elements?: ReadonlyArray<{ readonly height?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null, readonly columns?: ReadonlyArray<{ readonly elements?: ReadonlyArray<{ readonly height?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null> | null, readonly rows?: ReadonlyArray<{ readonly elements?: ReadonlyArray<{ readonly span?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null> | null } | null } | null> | null };

type FragmentMosaicPageContent_MosaicPageUnsegmentedContent_Fragment = { readonly __typename: 'MosaicPageUnsegmentedContent', readonly layout?: { readonly root?: { readonly elements?: ReadonlyArray<{ readonly height?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null, readonly columns?: ReadonlyArray<{ readonly elements?: ReadonlyArray<{ readonly height?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null> | null, readonly rows?: ReadonlyArray<{ readonly elements?: ReadonlyArray<{ readonly span?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null> | null } | null };

export type FragmentMosaicPageContentFragment = FragmentMosaicPageContent_MosaicPageSegmentedContent_Fragment | FragmentMosaicPageContent_MosaicPageUnsegmentedContent_Fragment;

export type MosaicPageQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  pageId: Scalars['ID']['input'];
}>;


export type MosaicPageQuery = { readonly tenant?: { readonly zone?: { readonly mosaicPage?: { readonly id?: string | null, readonly alias?: string | null, readonly name?: string | null, readonly description?: string | null, readonly hasQuery?: boolean | null, readonly content?: { readonly __typename: 'MosaicPageSegmentedContent', readonly navigator?: MosaicPageSegmentNavigator | null, readonly segments?: ReadonlyArray<{ readonly __typename: 'MosaicPageSegment', readonly alias?: string | null, readonly name?: string | null, readonly hasQuery?: boolean | null, readonly layout?: { readonly root?: { readonly elements?: ReadonlyArray<{ readonly height?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null, readonly columns?: ReadonlyArray<{ readonly elements?: ReadonlyArray<{ readonly height?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null> | null, readonly rows?: ReadonlyArray<{ readonly elements?: ReadonlyArray<{ readonly span?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null> | null } | null } | null> | null } | { readonly __typename: 'MosaicPageUnsegmentedContent', readonly layout?: { readonly root?: { readonly elements?: ReadonlyArray<{ readonly height?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null, readonly columns?: ReadonlyArray<{ readonly elements?: ReadonlyArray<{ readonly height?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null> | null, readonly rows?: ReadonlyArray<{ readonly elements?: ReadonlyArray<{ readonly span?: number | null, readonly ref?: { readonly __typename: 'MosaicPageLayoutListElementReference', readonly index?: number | null } | { readonly __typename: 'MosaicWidgetReference', readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null } | null } | null> | null } | null> | null } | null } | null, readonly variables?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null, readonly defaultValue?: any | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsInlineEnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null }> | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsMultiReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null } | null> | null } | null } | null } | null };

export type ExecuteMosaicActionMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  appPageId: Scalars['ID']['input'];
  actionIdentifier: FlexibleIdentifierInput;
  variableOverrides?: InputMaybe<ReadonlyArray<VariableValueInput> | VariableValueInput>;
}>;


export type ExecuteMosaicActionMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly mosaicPageRendering?: { readonly executeAction?: { readonly alias?: string | null, readonly id?: string | null, readonly executedInUi?: ReadonlyArray<{ readonly __typename: 'MosaicUiModalActionRendering', readonly widget?: { readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null } | { readonly __typename: 'MosaicUiNavigateActionRendering', readonly link?: { readonly goto?: { readonly navigationId?: string | null, readonly segmentId?: string | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null } | null } | { readonly __typename: 'MosaicUiOpenAssistantActionRendering', readonly agentId?: string | null, readonly records?: ReadonlyArray<{ readonly modelId: string, readonly recordId: string } | null> | null } | { readonly __typename: 'MosaicUiSetVariablesActionRendering', readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | { readonly __typename: 'MosaicUiSlideoutActionRendering', readonly widget?: { readonly identifier?: { readonly id?: string | null, readonly alias?: string | null } | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null } | null> | null } | null } | null } | null } | null } | null } | null };

export type MosaicPageRenderingInfoQueryVariables = Exact<{
  appPageId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  variableOverrides?: InputMaybe<ReadonlyArray<VariableValueInput> | VariableValueInput>;
}>;


export type MosaicPageRenderingInfoQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly mosaicPageRendering?: { readonly info?: { readonly title?: string | null, readonly breadcrumbs?: ReadonlyArray<{ readonly name?: string | null, readonly goto?: { readonly navigationId?: string | null, readonly segmentId?: string | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null } | null> | null } | null } | null } | null } | null } | null } | null };

export type MosaicPageSegmentInfoQueryVariables = Exact<{
  appPageId: Scalars['ID']['input'];
  pageId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  alias: Scalars['ID']['input'];
  variableOverrides?: InputMaybe<ReadonlyArray<VariableValueInput> | VariableValueInput>;
}>;


export type MosaicPageSegmentInfoQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly mosaicPageRendering?: { readonly segment?: { readonly name?: string | null, readonly hide?: boolean | null, readonly breadcrumbs?: ReadonlyArray<{ readonly name?: string | null, readonly goto?: { readonly navigationId?: string | null, readonly segmentId?: string | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null } | null> | null } | null } | null } | null } | null } | null } | null };

export type MosaicPageRenderingWidgetQueryVariables = Exact<{
  widgetIdentifier: FlexibleIdentifierInput;
  appPageId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  variableOverrides?: InputMaybe<ReadonlyArray<VariableValueInput> | VariableValueInput>;
}>;


export type MosaicPageRenderingWidgetQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly mosaicPageRendering?: { readonly widget?: { readonly id?: string | null, readonly payload?: any | null, readonly alias?: string | null, readonly variables?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null, readonly defaultValue?: any | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsInlineEnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null }> | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsMultiReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null } | null> | null } | null } | null } | null } | null } | null } | null };

export type AskAboutOrgChartMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  orgChartXml: Scalars['String']['input'];
  question: Scalars['String']['input'];
}>;


export type AskAboutOrgChartMutation = { readonly tenant?: { readonly zone?: { readonly askAboutOrgChart?: string | null } | null } | null };

export type DeleteTreeEditorDataMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  deletion: DataDeletion;
}>;


export type DeleteTreeEditorDataMutation = { readonly tenant?: { readonly zone?: { readonly deleteData?: boolean | null } | null } | null };

export type PutTreeEditorDataMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  insertion: DataInsertion;
}>;


export type PutTreeEditorDataMutation = { readonly tenant?: { readonly zone?: { readonly putData?: boolean | null } | null } | null };

export type QueryTreeEditorEdgesQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  query: Scalars['AWSJSON']['input'];
}>;


export type QueryTreeEditorEdgesQuery = { readonly tenant?: { readonly zone?: { readonly data?: any | null } | null } | null };

export type QueryTreeEditorNodePeopleInsightsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  query: Scalars['AWSJSON']['input'];
}>;


export type QueryTreeEditorNodePeopleInsightsQuery = { readonly tenant?: { readonly zone?: { readonly data?: any | null } | null } | null };

export type FragmentQuiverEvaluationCompleteFragment = { readonly commands?: ReadonlyArray<{ readonly operation?: string | null, readonly payload?: any | null } | null> | null };

export type FragmentQuiverEvaluationIncompleteFragment = { readonly requires?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null, readonly defaultValue?: any | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsInlineEnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null }> | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsMultiReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null } | null> | null };

type FragmentQuiverEvaluation_QuiverEvaluationComplete_Fragment = { readonly __typename: 'QuiverEvaluationComplete', readonly commands?: ReadonlyArray<{ readonly operation?: string | null, readonly payload?: any | null } | null> | null };

type FragmentQuiverEvaluation_QuiverEvaluationIncomplete_Fragment = { readonly __typename: 'QuiverEvaluationIncomplete', readonly requires?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null, readonly defaultValue?: any | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsInlineEnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null }> | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsMultiReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null } | null> | null };

export type FragmentQuiverEvaluationFragment = FragmentQuiverEvaluation_QuiverEvaluationComplete_Fragment | FragmentQuiverEvaluation_QuiverEvaluationIncomplete_Fragment;

export type QuiverDeployMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  commands: ReadonlyArray<RelayCommandInput> | RelayCommandInput;
}>;


export type QuiverDeployMutation = { readonly tenant?: { readonly zone?: { readonly execute?: Void | null } | null } | null };

export type QuiverEvaluateQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  resourceIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
  variables?: InputMaybe<ReadonlyArray<VariableValueInput> | VariableValueInput>;
}>;


export type QuiverEvaluateQuery = { readonly tenant?: { readonly zone?: { readonly quiver?: { readonly evaluate?: { readonly __typename: 'QuiverEvaluationComplete', readonly commands?: ReadonlyArray<{ readonly operation?: string | null, readonly payload?: any | null } | null> | null } | { readonly __typename: 'QuiverEvaluationIncomplete', readonly requires?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null, readonly defaultValue?: any | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsInlineEnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null }> | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsMultiReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null } | null> | null } | null } | null } | null } | null };

export type AdjustmentLabelsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
}>;


export type AdjustmentLabelsQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly rate?: { readonly adjustmentLabels?: ReadonlyArray<string | null> | null } | null } | null } | null } | null } | null } | null };

export type DistributionsQueryVariables = Exact<{
  scenarioId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
}>;


export type DistributionsQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly rate?: { readonly allocationDistributionsPerFaFunctionCategory?: ReadonlyArray<{ readonly distributions?: ReadonlyArray<{ readonly name?: string | null, readonly amountToAllocate?: number | null, readonly allocations?: ReadonlyArray<{ readonly percent?: number | null, readonly dollars?: number | null, readonly recipient?: { readonly id: string } | null } | null> | null } | null> | null, readonly faFunctionCategory?: { readonly id: string } | null } | null> | null } | null } | null } | null } | null } | null } | null };

export type ExclusionLabelsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
}>;


export type ExclusionLabelsQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly rate?: { readonly exclusionLabels?: ReadonlyArray<string | null> | null } | null } | null } | null } | null } | null } | null };

export type FragmentGeneralLedgerFilterComparisonFragment = { readonly __typename: 'GeneralLedgerFilterComparison', readonly attributeId?: string | null, readonly operator?: GeneralLedgerFilterComparisonOperator | null, readonly value?: { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null } | null };

type FragmentGeneralLedgerFilter_GeneralLedgerFilterComparison_Fragment = { readonly __typename: 'GeneralLedgerFilterComparison', readonly attributeId?: string | null, readonly operator?: GeneralLedgerFilterComparisonOperator | null, readonly value?: { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null } | null };

type FragmentGeneralLedgerFilter_GeneralLedgerFilterSelection_Fragment = { readonly __typename: 'GeneralLedgerFilterSelection', readonly attributeId?: string | null, readonly values?: ReadonlyArray<string | null> | null };

type FragmentGeneralLedgerFilter_GeneralLedgerFilterStatement_Fragment = { readonly __typename: 'GeneralLedgerFilterStatement', readonly statements?: ReadonlyArray<{ readonly connector?: GeneralLedgerFilterStatementConnector | null, readonly elements?: ReadonlyArray<{ readonly __typename: 'GeneralLedgerFilterComparison', readonly attributeId?: string | null, readonly operator?: GeneralLedgerFilterComparisonOperator | null, readonly value?: { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null } | null } | { readonly __typename: 'GeneralLedgerFilterNestedStatementReference', readonly nestedStatementIdx?: number | null } | { readonly __typename: 'GeneralLedgerFilterSelection', readonly attributeId?: string | null, readonly values?: ReadonlyArray<string | null> | null } | null> | null } | null> | null };

export type FragmentGeneralLedgerFilterFragment = FragmentGeneralLedgerFilter_GeneralLedgerFilterComparison_Fragment | FragmentGeneralLedgerFilter_GeneralLedgerFilterSelection_Fragment | FragmentGeneralLedgerFilter_GeneralLedgerFilterStatement_Fragment;

export type FragmentGeneralLedgerFilterSelectionFragment = { readonly __typename: 'GeneralLedgerFilterSelection', readonly attributeId?: string | null, readonly values?: ReadonlyArray<string | null> | null };

type FragmentGeneralLedgerFilterStatementElement_GeneralLedgerFilterComparison_Fragment = { readonly __typename: 'GeneralLedgerFilterComparison', readonly attributeId?: string | null, readonly operator?: GeneralLedgerFilterComparisonOperator | null, readonly value?: { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null } | null };

type FragmentGeneralLedgerFilterStatementElement_GeneralLedgerFilterNestedStatementReference_Fragment = { readonly __typename: 'GeneralLedgerFilterNestedStatementReference', readonly nestedStatementIdx?: number | null };

type FragmentGeneralLedgerFilterStatementElement_GeneralLedgerFilterSelection_Fragment = { readonly __typename: 'GeneralLedgerFilterSelection', readonly attributeId?: string | null, readonly values?: ReadonlyArray<string | null> | null };

export type FragmentGeneralLedgerFilterStatementElementFragment = FragmentGeneralLedgerFilterStatementElement_GeneralLedgerFilterComparison_Fragment | FragmentGeneralLedgerFilterStatementElement_GeneralLedgerFilterNestedStatementReference_Fragment | FragmentGeneralLedgerFilterStatementElement_GeneralLedgerFilterSelection_Fragment;

export type FragmentGeneralLedgerFilterNestedStatementFragment = { readonly connector?: GeneralLedgerFilterStatementConnector | null, readonly elements?: ReadonlyArray<{ readonly __typename: 'GeneralLedgerFilterComparison', readonly attributeId?: string | null, readonly operator?: GeneralLedgerFilterComparisonOperator | null, readonly value?: { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null } | null } | { readonly __typename: 'GeneralLedgerFilterNestedStatementReference', readonly nestedStatementIdx?: number | null } | { readonly __typename: 'GeneralLedgerFilterSelection', readonly attributeId?: string | null, readonly values?: ReadonlyArray<string | null> | null } | null> | null };

export type FragmentGeneralLedgerFilterStatementFragment = { readonly __typename: 'GeneralLedgerFilterStatement', readonly statements?: ReadonlyArray<{ readonly connector?: GeneralLedgerFilterStatementConnector | null, readonly elements?: ReadonlyArray<{ readonly __typename: 'GeneralLedgerFilterComparison', readonly attributeId?: string | null, readonly operator?: GeneralLedgerFilterComparisonOperator | null, readonly value?: { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null } | null } | { readonly __typename: 'GeneralLedgerFilterNestedStatementReference', readonly nestedStatementIdx?: number | null } | { readonly __typename: 'GeneralLedgerFilterSelection', readonly attributeId?: string | null, readonly values?: ReadonlyArray<string | null> | null } | null> | null } | null> | null };

export type FragmentRateMappingEntryFragment = { readonly exclusionLabel?: string | null, readonly percent?: number | null, readonly categorization?: { readonly category?: { readonly id: string } | null, readonly subcategory?: { readonly id: string } | null } | null };

export type FragmentRateMappingFragment = { readonly adjustmentLabel?: string | null, readonly entries?: ReadonlyArray<{ readonly exclusionLabel?: string | null, readonly percent?: number | null, readonly categorization?: { readonly category?: { readonly id: string } | null, readonly subcategory?: { readonly id: string } | null } | null } | null> | null };

export type FragmentGeneralLedgerRecordAttributeFragment = { readonly id: string, readonly value?: { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null } | null };

export type FragmentGeneralLedgerRecordFragment = { readonly id: string, readonly applicableRuleIds: ReadonlyArray<string>, readonly attributes?: ReadonlyArray<{ readonly id: string, readonly value?: { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null } | null } | null> | null, readonly originalMapping?: { readonly adjustmentLabel?: string | null, readonly entries?: ReadonlyArray<{ readonly exclusionLabel?: string | null, readonly percent?: number | null, readonly categorization?: { readonly category?: { readonly id: string } | null, readonly subcategory?: { readonly id: string } | null } | null } | null> | null } | null };

export type GlAttributesQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
}>;


export type GlAttributesQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly rate?: { readonly glAttributes?: ReadonlyArray<{ readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly note?: string | null, readonly default?: any | null, readonly computation?: any | null, readonly isOptional?: boolean | null, readonly canBeOptional?: boolean | null, readonly terms?: ReadonlyArray<{ readonly id: string }> | null, readonly type?: { readonly __typename: 'DmsEnumValueType', readonly enumId?: string | null, readonly isMultiselect?: boolean | null } | { readonly __typename: 'DmsFilesValueType', readonly isFile?: boolean | null } | { readonly __typename: 'DmsIntrinsicValueType', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'DmsReferenceValueType', readonly dimensionId?: string | null } | { readonly __typename: 'DmsStructureValueType', readonly structureId?: string | null } | null, readonly constraints?: { readonly acceptable?: ReadonlyArray<any | null> | null, readonly unacceptable?: ReadonlyArray<any | null> | null, readonly pattern?: string | null, readonly minLength?: number | null, readonly maxLength?: number | null, readonly max?: any | null, readonly min?: any | null } | null, readonly scoring?: { readonly default?: number | null, readonly lookup?: ReadonlyArray<{ readonly key?: string | null, readonly value?: number | null }> | null } | null } | null> | null } | null } | null } | null } | null } | null } | null };

export type GeneralLedgerCountQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GeneralLedgerFilterInput>;
}>;


export type GeneralLedgerCountQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly rate?: { readonly glCount?: number | null } | null } | null } | null } | null } | null } | null };

export type GeneralLedgerQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<GeneralLedgerSortInput>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GeneralLedgerFilterInput>;
}>;


export type GeneralLedgerQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly rate?: { readonly glRecords?: ReadonlyArray<{ readonly id: string, readonly applicableRuleIds: ReadonlyArray<string>, readonly attributes?: ReadonlyArray<{ readonly id: string, readonly value?: { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null } | null } | null> | null, readonly originalMapping?: { readonly adjustmentLabel?: string | null, readonly entries?: ReadonlyArray<{ readonly exclusionLabel?: string | null, readonly percent?: number | null, readonly categorization?: { readonly category?: { readonly id: string } | null, readonly subcategory?: { readonly id: string } | null } | null } | null> | null } | null } | null> | null } | null } | null } | null } | null } | null } | null };

export type FragmentRateRuleFragment = { readonly id: string, readonly name?: string | null, readonly priority?: number | null, readonly isActive?: boolean | null, readonly mapping?: { readonly adjustmentLabel?: string | null, readonly entries?: ReadonlyArray<{ readonly exclusionLabel?: string | null, readonly percent?: number | null, readonly categorization?: { readonly category?: { readonly id: string } | null, readonly subcategory?: { readonly id: string } | null } | null } | null> | null } | null, readonly filter?: { readonly __typename: 'GeneralLedgerFilterComparison', readonly attributeId?: string | null, readonly operator?: GeneralLedgerFilterComparisonOperator | null, readonly value?: { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null } | null } | { readonly __typename: 'GeneralLedgerFilterSelection', readonly attributeId?: string | null, readonly values?: ReadonlyArray<string | null> | null } | { readonly __typename: 'GeneralLedgerFilterStatement', readonly statements?: ReadonlyArray<{ readonly connector?: GeneralLedgerFilterStatementConnector | null, readonly elements?: ReadonlyArray<{ readonly __typename: 'GeneralLedgerFilterComparison', readonly attributeId?: string | null, readonly operator?: GeneralLedgerFilterComparisonOperator | null, readonly value?: { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null } | null } | { readonly __typename: 'GeneralLedgerFilterNestedStatementReference', readonly nestedStatementIdx?: number | null } | { readonly __typename: 'GeneralLedgerFilterSelection', readonly attributeId?: string | null, readonly values?: ReadonlyArray<string | null> | null } | null> | null } | null> | null } | null };

export type ApplyRateRulesMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
}>;


export type ApplyRateRulesMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly rate?: { readonly applyRules?: Void | null } | null } | null } | null } | null } | null } | null };

export type CreateRateRuleMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  input: RateRuleInput;
}>;


export type CreateRateRuleMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly rate?: { readonly createRule?: { readonly id: string, readonly name?: string | null, readonly priority?: number | null, readonly isActive?: boolean | null, readonly mapping?: { readonly adjustmentLabel?: string | null, readonly entries?: ReadonlyArray<{ readonly exclusionLabel?: string | null, readonly percent?: number | null, readonly categorization?: { readonly category?: { readonly id: string } | null, readonly subcategory?: { readonly id: string } | null } | null } | null> | null } | null, readonly filter?: { readonly __typename: 'GeneralLedgerFilterComparison', readonly attributeId?: string | null, readonly operator?: GeneralLedgerFilterComparisonOperator | null, readonly value?: { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null } | null } | { readonly __typename: 'GeneralLedgerFilterSelection', readonly attributeId?: string | null, readonly values?: ReadonlyArray<string | null> | null } | { readonly __typename: 'GeneralLedgerFilterStatement', readonly statements?: ReadonlyArray<{ readonly connector?: GeneralLedgerFilterStatementConnector | null, readonly elements?: ReadonlyArray<{ readonly __typename: 'GeneralLedgerFilterComparison', readonly attributeId?: string | null, readonly operator?: GeneralLedgerFilterComparisonOperator | null, readonly value?: { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null } | null } | { readonly __typename: 'GeneralLedgerFilterNestedStatementReference', readonly nestedStatementIdx?: number | null } | { readonly __typename: 'GeneralLedgerFilterSelection', readonly attributeId?: string | null, readonly values?: ReadonlyArray<string | null> | null } | null> | null } | null> | null } | null } | null } | null } | null } | null } | null } | null } | null };

export type DeleteRateRuleMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type DeleteRateRuleMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly rate?: { readonly deleteRule?: { readonly id: string, readonly name?: string | null, readonly priority?: number | null, readonly isActive?: boolean | null, readonly mapping?: { readonly adjustmentLabel?: string | null, readonly entries?: ReadonlyArray<{ readonly exclusionLabel?: string | null, readonly percent?: number | null, readonly categorization?: { readonly category?: { readonly id: string } | null, readonly subcategory?: { readonly id: string } | null } | null } | null> | null } | null, readonly filter?: { readonly __typename: 'GeneralLedgerFilterComparison', readonly attributeId?: string | null, readonly operator?: GeneralLedgerFilterComparisonOperator | null, readonly value?: { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null } | null } | { readonly __typename: 'GeneralLedgerFilterSelection', readonly attributeId?: string | null, readonly values?: ReadonlyArray<string | null> | null } | { readonly __typename: 'GeneralLedgerFilterStatement', readonly statements?: ReadonlyArray<{ readonly connector?: GeneralLedgerFilterStatementConnector | null, readonly elements?: ReadonlyArray<{ readonly __typename: 'GeneralLedgerFilterComparison', readonly attributeId?: string | null, readonly operator?: GeneralLedgerFilterComparisonOperator | null, readonly value?: { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null } | null } | { readonly __typename: 'GeneralLedgerFilterNestedStatementReference', readonly nestedStatementIdx?: number | null } | { readonly __typename: 'GeneralLedgerFilterSelection', readonly attributeId?: string | null, readonly values?: ReadonlyArray<string | null> | null } | null> | null } | null> | null } | null } | null } | null } | null } | null } | null } | null } | null };

export type UpdateRateRuleMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  updates: RateRuleUpdates;
}>;


export type UpdateRateRuleMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly rate?: { readonly updateRule?: { readonly id: string, readonly name?: string | null, readonly priority?: number | null, readonly isActive?: boolean | null, readonly mapping?: { readonly adjustmentLabel?: string | null, readonly entries?: ReadonlyArray<{ readonly exclusionLabel?: string | null, readonly percent?: number | null, readonly categorization?: { readonly category?: { readonly id: string } | null, readonly subcategory?: { readonly id: string } | null } | null } | null> | null } | null, readonly filter?: { readonly __typename: 'GeneralLedgerFilterComparison', readonly attributeId?: string | null, readonly operator?: GeneralLedgerFilterComparisonOperator | null, readonly value?: { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null } | null } | { readonly __typename: 'GeneralLedgerFilterSelection', readonly attributeId?: string | null, readonly values?: ReadonlyArray<string | null> | null } | { readonly __typename: 'GeneralLedgerFilterStatement', readonly statements?: ReadonlyArray<{ readonly connector?: GeneralLedgerFilterStatementConnector | null, readonly elements?: ReadonlyArray<{ readonly __typename: 'GeneralLedgerFilterComparison', readonly attributeId?: string | null, readonly operator?: GeneralLedgerFilterComparisonOperator | null, readonly value?: { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null } | null } | { readonly __typename: 'GeneralLedgerFilterNestedStatementReference', readonly nestedStatementIdx?: number | null } | { readonly __typename: 'GeneralLedgerFilterSelection', readonly attributeId?: string | null, readonly values?: ReadonlyArray<string | null> | null } | null> | null } | null> | null } | null } | null } | null } | null } | null } | null } | null } | null };

export type RuleQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  ruleId: Scalars['ID']['input'];
}>;


export type RuleQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly rate?: { readonly rule?: { readonly id: string, readonly name?: string | null, readonly priority?: number | null, readonly isActive?: boolean | null, readonly mapping?: { readonly adjustmentLabel?: string | null, readonly entries?: ReadonlyArray<{ readonly exclusionLabel?: string | null, readonly percent?: number | null, readonly categorization?: { readonly category?: { readonly id: string } | null, readonly subcategory?: { readonly id: string } | null } | null } | null> | null } | null, readonly filter?: { readonly __typename: 'GeneralLedgerFilterComparison', readonly attributeId?: string | null, readonly operator?: GeneralLedgerFilterComparisonOperator | null, readonly value?: { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null } | null } | { readonly __typename: 'GeneralLedgerFilterSelection', readonly attributeId?: string | null, readonly values?: ReadonlyArray<string | null> | null } | { readonly __typename: 'GeneralLedgerFilterStatement', readonly statements?: ReadonlyArray<{ readonly connector?: GeneralLedgerFilterStatementConnector | null, readonly elements?: ReadonlyArray<{ readonly __typename: 'GeneralLedgerFilterComparison', readonly attributeId?: string | null, readonly operator?: GeneralLedgerFilterComparisonOperator | null, readonly value?: { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null } | null } | { readonly __typename: 'GeneralLedgerFilterNestedStatementReference', readonly nestedStatementIdx?: number | null } | { readonly __typename: 'GeneralLedgerFilterSelection', readonly attributeId?: string | null, readonly values?: ReadonlyArray<string | null> | null } | null> | null } | null> | null } | null } | null } | null } | null } | null } | null } | null } | null };

export type RulesQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
}>;


export type RulesQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly rate?: { readonly rules?: ReadonlyArray<{ readonly id: string, readonly name?: string | null, readonly priority?: number | null, readonly isActive?: boolean | null, readonly mapping?: { readonly adjustmentLabel?: string | null, readonly entries?: ReadonlyArray<{ readonly exclusionLabel?: string | null, readonly percent?: number | null, readonly categorization?: { readonly category?: { readonly id: string } | null, readonly subcategory?: { readonly id: string } | null } | null } | null> | null } | null, readonly filter?: { readonly __typename: 'GeneralLedgerFilterComparison', readonly attributeId?: string | null, readonly operator?: GeneralLedgerFilterComparisonOperator | null, readonly value?: { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null } | null } | { readonly __typename: 'GeneralLedgerFilterSelection', readonly attributeId?: string | null, readonly values?: ReadonlyArray<string | null> | null } | { readonly __typename: 'GeneralLedgerFilterStatement', readonly statements?: ReadonlyArray<{ readonly connector?: GeneralLedgerFilterStatementConnector | null, readonly elements?: ReadonlyArray<{ readonly __typename: 'GeneralLedgerFilterComparison', readonly attributeId?: string | null, readonly operator?: GeneralLedgerFilterComparisonOperator | null, readonly value?: { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null } | null } | { readonly __typename: 'GeneralLedgerFilterNestedStatementReference', readonly nestedStatementIdx?: number | null } | { readonly __typename: 'GeneralLedgerFilterSelection', readonly attributeId?: string | null, readonly values?: ReadonlyArray<string | null> | null } | null> | null } | null> | null } | null } | null> | null } | null } | null } | null } | null } | null } | null };

export type FaFunctionCategoryWithSubcategoriesQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
}>;


export type FaFunctionCategoryWithSubcategoriesQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly faFunctionCategories?: ReadonlyArray<{ readonly category: { readonly id: string, readonly code?: string | null, readonly name?: string | null, readonly type?: FaFunctionType | null }, readonly subcategories?: ReadonlyArray<{ readonly id: string, readonly code?: string | null, readonly name?: string | null, readonly isUtilityRelated?: boolean | null }> | null } | null> | null } | null } | null } | null } | null } | null };

export type FragmentRateReportLabelFragment = { readonly code?: string | null, readonly hint?: string | null, readonly id?: string | null, readonly isActive?: boolean | null, readonly name?: string | null, readonly position?: number | null, readonly faFunctionCategorization?: { readonly category?: { readonly id: string } | null, readonly subcategory?: { readonly id: string } | null } | null };

export type ReportLabelsQueryVariables = Exact<{
  scenarioId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
}>;


export type ReportLabelsQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly rate?: { readonly reportLabels?: ReadonlyArray<{ readonly code?: string | null, readonly hint?: string | null, readonly id?: string | null, readonly isActive?: boolean | null, readonly name?: string | null, readonly position?: number | null, readonly faFunctionCategorization?: { readonly category?: { readonly id: string } | null, readonly subcategory?: { readonly id: string } | null } | null } | null> | null } | null } | null } | null } | null } | null } | null };

export type ReportQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
}>;


export type ReportQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly rate?: { readonly report?: { readonly content?: { readonly rows: ReadonlyArray<{ readonly cells: ReadonlyArray<{ readonly align?: TextAlignment | null, readonly columnSpan?: number | null, readonly indents?: number | null, readonly style?: ReportCellStyle | null, readonly content?: { readonly raw?: any | null, readonly info?: { readonly precision?: number | null, readonly type?: { readonly __typename: 'EnumValueType', readonly isMultiselect?: boolean | null, readonly entries?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly description?: string | null } | null> | null } | { readonly __typename: 'IntrinsicValueTypeWrapper', readonly intrinsic?: IntrinsicValueType | null } | { readonly __typename: 'StructureValueTypeList' } | { readonly __typename: 'StructureValueTypeObject' } | { readonly __typename: 'StructureValueTypeTuple' } | null } | null } | null } | null> } | null>, readonly columns?: ReadonlyArray<{ readonly width?: number | null } | null> | null } | null, readonly label?: { readonly code?: string | null, readonly hint?: string | null, readonly id?: string | null, readonly isActive?: boolean | null, readonly name?: string | null, readonly position?: number | null, readonly faFunctionCategorization?: { readonly category?: { readonly id: string } | null, readonly subcategory?: { readonly id: string } | null } | null } | null } | null } | null } | null } | null } | null } | null } | null };

export type FragmentRelayCommandFragment = { readonly operation?: string | null, readonly payload?: any | null };

export type FragmentProcessEssentialsFragment = { readonly appId?: string | null, readonly zoneId?: string | null, readonly id?: string | null, readonly scenarioId?: string | null, readonly templateId?: string | null, readonly tenantId?: string | null, readonly activities?: ReadonlyArray<{ readonly type?: ProcessActivityType | null, readonly id?: string | null, readonly extra?: string | null, readonly execution?: { readonly status?: ProcessExecutionStatus | null, readonly detail?: string | null, readonly timeframe?: { readonly end?: any | null, readonly start?: any | null } | null } | null, readonly item?: { readonly type?: ProcessItemType | null, readonly id?: string | null } | null } | null> | null, readonly execution?: { readonly status?: ProcessExecutionStatus | null, readonly detail?: string | null, readonly timeframe?: { readonly end?: any | null, readonly start?: any | null } | null } | null, readonly items?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly type?: ProcessItemType | null } | null> | null };

export type DismissProcessMutationVariables = Exact<{
  process: ProcessEssentialsDismissInput;
}>;


export type DismissProcessMutation = { readonly dismissProcess?: boolean | null };

export type StopProcessMutationVariables = Exact<{
  process: ProcessEssentialsDismissInput;
}>;


export type StopProcessMutation = { readonly stopProcess?: boolean | null };

export type AppProcessesQueryVariables = Exact<{
  zoneId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
}>;


export type AppProcessesQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly processes?: ReadonlyArray<{ readonly appId?: string | null, readonly zoneId?: string | null, readonly id?: string | null, readonly scenarioId?: string | null, readonly templateId?: string | null, readonly tenantId?: string | null, readonly activities?: ReadonlyArray<{ readonly type?: ProcessActivityType | null, readonly id?: string | null, readonly extra?: string | null, readonly execution?: { readonly status?: ProcessExecutionStatus | null, readonly detail?: string | null, readonly timeframe?: { readonly end?: any | null, readonly start?: any | null } | null } | null, readonly item?: { readonly type?: ProcessItemType | null, readonly id?: string | null } | null } | null> | null, readonly execution?: { readonly status?: ProcessExecutionStatus | null, readonly detail?: string | null, readonly timeframe?: { readonly end?: any | null, readonly start?: any | null } | null } | null, readonly items?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly type?: ProcessItemType | null } | null> | null } | null> | null } | null } | null } | null };

export type ScenarioProcessesQueryVariables = Exact<{
  zoneId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
}>;


export type ScenarioProcessesQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly processes?: ReadonlyArray<{ readonly appId?: string | null, readonly zoneId?: string | null, readonly id?: string | null, readonly scenarioId?: string | null, readonly templateId?: string | null, readonly tenantId?: string | null, readonly activities?: ReadonlyArray<{ readonly type?: ProcessActivityType | null, readonly id?: string | null, readonly extra?: string | null, readonly execution?: { readonly status?: ProcessExecutionStatus | null, readonly detail?: string | null, readonly timeframe?: { readonly end?: any | null, readonly start?: any | null } | null } | null, readonly item?: { readonly type?: ProcessItemType | null, readonly id?: string | null } | null } | null> | null, readonly execution?: { readonly status?: ProcessExecutionStatus | null, readonly detail?: string | null, readonly timeframe?: { readonly end?: any | null, readonly start?: any | null } | null } | null, readonly items?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly type?: ProcessItemType | null } | null> | null } | null> | null } | null } | null } | null } | null };

export type ZoneProcessesQueryVariables = Exact<{
  zoneId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
}>;


export type ZoneProcessesQuery = { readonly tenant?: { readonly zone?: { readonly processes?: ReadonlyArray<{ readonly appId?: string | null, readonly zoneId?: string | null, readonly id?: string | null, readonly scenarioId?: string | null, readonly templateId?: string | null, readonly tenantId?: string | null, readonly activities?: ReadonlyArray<{ readonly type?: ProcessActivityType | null, readonly id?: string | null, readonly extra?: string | null, readonly execution?: { readonly status?: ProcessExecutionStatus | null, readonly detail?: string | null, readonly timeframe?: { readonly end?: any | null, readonly start?: any | null } | null } | null, readonly item?: { readonly type?: ProcessItemType | null, readonly id?: string | null } | null } | null> | null, readonly execution?: { readonly status?: ProcessExecutionStatus | null, readonly detail?: string | null, readonly timeframe?: { readonly end?: any | null, readonly start?: any | null } | null } | null, readonly items?: ReadonlyArray<{ readonly id?: string | null, readonly name?: string | null, readonly type?: ProcessItemType | null } | null> | null } | null> | null } | null } | null };

export type CreateAppScenarioMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  input: ScenarioInput;
}>;


export type CreateAppScenarioMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly createScenario?: boolean | null } | null } | null } | null };

export type DeleteAppScenarioMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
}>;


export type DeleteAppScenarioMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly deleteScenario?: { readonly id: string } | null } | null } | null } | null };

export type UpdateAppScenarioMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  updates: ScenarioUpdates;
}>;


export type UpdateAppScenarioMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly updateScenario?: { readonly id: string } | null } | null } | null } | null };

export type ScenariosQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
}>;


export type ScenariosQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenarios?: { readonly nextCursor?: string | null, readonly items?: ReadonlyArray<{ readonly id: string, readonly alias?: string | null, readonly name?: string | null, readonly description?: string | null, readonly createdBy?: string | null, readonly visibility?: ScenarioVisibility | null, readonly period?: { readonly startDate?: any | null, readonly endDate?: any | null } | null, readonly variables?: ReadonlyArray<{ readonly variable?: string | null, readonly value?: any | null } | null> | null } | null> | null } | null } | null } | null } | null };

export type SpaceFilterOptionsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  ancestorEntityId?: InputMaybe<Scalars['ID']['input']>;
  ancestorIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type SpaceFilterOptionsQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spaceFilterOptions?: ReadonlyArray<{ readonly code: string, readonly id: string, readonly name: string, readonly prefix?: string | null } | null> | null } | null } | null } | null } | null } | null } | null };

export type AddSpaceRecordsToClusterMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  clusterId: Scalars['ID']['input'];
  spaceRecordIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddSpaceRecordsToClusterMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly addSpaceRecordsToCluster?: Void | null } | null } | null } | null } | null } | null } | null };

export type RemoveSpaceRecordFromClusterMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  clusterId: Scalars['ID']['input'];
  spaceRecordId: Scalars['ID']['input'];
}>;


export type RemoveSpaceRecordFromClusterMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly removeSpaceRecordFromCluster?: Void | null } | null } | null } | null } | null } | null } | null };

export type FragmentSpaceClusterFragment = { readonly id: string, readonly name: string, readonly code: string, readonly description?: string | null, readonly assignedSpaceIds: ReadonlyArray<string>, readonly organization: any, readonly comment?: string | null };

export type CreateSpaceClusterMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  input: ClusterInput;
}>;


export type CreateSpaceClusterMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly createCluster?: { readonly id: string, readonly name: string, readonly code: string, readonly description?: string | null, readonly assignedSpaceIds: ReadonlyArray<string>, readonly organization: any, readonly comment?: string | null } | null } | null } | null } | null } | null } | null } | null };

export type DeleteSpaceClusterMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type DeleteSpaceClusterMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly deleteCluster?: Void | null } | null } | null } | null } | null } | null } | null };

export type UpdateSpaceClusterMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  clusterId: Scalars['ID']['input'];
  input: ClusterUpdateInput;
}>;


export type UpdateSpaceClusterMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly updateCluster?: { readonly id: string, readonly name: string, readonly code: string, readonly description?: string | null, readonly assignedSpaceIds: ReadonlyArray<string>, readonly organization: any, readonly comment?: string | null } | null } | null } | null } | null } | null } | null } | null };

export type SpaceClusterQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  clusterId: Scalars['ID']['input'];
}>;


export type SpaceClusterQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly cluster?: { readonly id: string, readonly name: string, readonly code: string, readonly description?: string | null, readonly assignedSpaceIds: ReadonlyArray<string>, readonly organization: any, readonly comment?: string | null } | null } | null } | null } | null } | null } | null } | null };

export type SpaceClustersQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
}>;


export type SpaceClustersQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly clusters?: ReadonlyArray<{ readonly id: string, readonly name: string, readonly code: string, readonly description?: string | null, readonly assignedSpaceIds: ReadonlyArray<string>, readonly organization: any, readonly comment?: string | null } | null> | null } | null } | null } | null } | null } | null } | null };

export type UpdateClusterFunctionalUsageMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  clusterId: Scalars['ID']['input'];
  functionalizations?: InputMaybe<ReadonlyArray<SpaceFunctionalizationInput> | SpaceFunctionalizationInput>;
}>;


export type UpdateClusterFunctionalUsageMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly updateClusterFunctionalUsage?: ReadonlyArray<{ readonly functionId: string, readonly percent: number } | null> | null } | null } | null } | null } | null } | null } | null };

export type ClusterFunctionalUsageQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  clusterId: Scalars['ID']['input'];
}>;


export type ClusterFunctionalUsageQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly clusterFunctionalUsage?: ReadonlyArray<{ readonly functionId: string, readonly percent: number } | null> | null } | null } | null } | null } | null } | null } | null };

export type SpaceClusterWarningsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  clusterId: Scalars['ID']['input'];
}>;


export type SpaceClusterWarningsQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spaceClusterWarnings?: ReadonlyArray<{ readonly code: SpaceWarningCode, readonly message: string }> | null } | null } | null } | null } | null } | null } | null };

export type FragmentSpaceEmployeeFragment = { readonly code: string, readonly description?: string | null, readonly id: string, readonly jobTitleId?: string | null, readonly name: string, readonly organization: { readonly entityId: string, readonly recordId: string } };

export type CreateSpaceEmployeeMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  input: SpaceEmployeeInput;
}>;


export type CreateSpaceEmployeeMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly createEmployee?: { readonly code: string, readonly description?: string | null, readonly id: string, readonly jobTitleId?: string | null, readonly name: string, readonly organization: { readonly entityId: string, readonly recordId: string } } | null } | null } | null } | null } | null } | null } | null };

export type SpaceEmployeesQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  filter?: InputMaybe<SpaceEmployeeFilter>;
}>;


export type SpaceEmployeesQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spaceEmployees?: ReadonlyArray<{ readonly code: string, readonly description?: string | null, readonly id: string, readonly jobTitleId?: string | null, readonly name: string, readonly organization: { readonly entityId: string, readonly recordId: string } }> | null } | null } | null } | null } | null } | null } | null };

export type SpaceFunctionsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
}>;


export type SpaceFunctionsQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spaceFunctions?: ReadonlyArray<{ readonly code: string, readonly description?: string | null, readonly id: string, readonly isExclusive?: boolean | null, readonly isRequiredForMatchingPayroll?: boolean | null, readonly isSponsored: boolean, readonly name: string, readonly idcCategorization?: { readonly category: { readonly code: string, readonly id: string, readonly name: string }, readonly subcategory?: { readonly code: string, readonly id: string, readonly name: string } | null } | null }> | null } | null } | null } | null } | null } | null } | null };

export type SpaceJobTitlesQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
}>;


export type SpaceJobTitlesQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly jobTitles?: ReadonlyArray<{ readonly id: string, readonly name: string, readonly code: string, readonly description?: string | null }> | null } | null } | null } | null } | null } | null } | null };

export type AddClusterOccupantsMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  clusterId: Scalars['ID']['input'];
  employeeIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddClusterOccupantsMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly addClusterOccupants?: Void | null } | null } | null } | null } | null } | null } | null };

export type AllocateClusterOccupantPayrollsMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  clusterId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
  payrollIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AllocateClusterOccupantPayrollsMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly allocateClusterOccupantPayrolls?: Void | null } | null } | null } | null } | null } | null } | null };

export type RemoveClusterOccupantMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  clusterId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
}>;


export type RemoveClusterOccupantMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly removeClusterOccupant?: Void | null } | null } | null } | null } | null } | null } | null };

export type ClusterOccupantsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  clusterId: Scalars['ID']['input'];
}>;


export type ClusterOccupantsQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly clusterOccupants?: ReadonlyArray<{ readonly id: string, readonly employee: { readonly code: string, readonly description?: string | null, readonly id: string, readonly jobTitleId?: string | null, readonly name: string, readonly organization: { readonly entityId: string, readonly recordId: string } }, readonly payrolls: ReadonlyArray<{ readonly payrollIds: ReadonlyArray<string>, readonly assignment: OccupantPayrollAssignment, readonly percent: number, readonly project?: { readonly code: string, readonly name: string } | null, readonly organization: { readonly name: string }, readonly idcAllocations: ReadonlyArray<{ readonly percent: number, readonly idcCategorization: { readonly category: { readonly code: string }, readonly subcategory?: { readonly code: string } | null } }> }> } | null> | null } | null } | null } | null } | null } | null } | null };

export type FragmentOccupantFragment = { readonly id: string, readonly employee: { readonly code: string, readonly description?: string | null, readonly id: string, readonly jobTitleId?: string | null, readonly name: string, readonly organization: { readonly entityId: string, readonly recordId: string } }, readonly payrolls: ReadonlyArray<{ readonly payrollIds: ReadonlyArray<string>, readonly assignment: OccupantPayrollAssignment, readonly percent: number, readonly project?: { readonly code: string, readonly name: string } | null, readonly organization: { readonly name: string }, readonly idcAllocations: ReadonlyArray<{ readonly percent: number, readonly idcCategorization: { readonly category: { readonly code: string }, readonly subcategory?: { readonly code: string } | null } }> }> };

export type AddRecordOccupantsMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordId: Scalars['ID']['input'];
  employeeIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddRecordOccupantsMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly addOccupants?: Void | null } | null } | null } | null } | null } | null } | null };

export type AllocateRecordOccupantPayrollsMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
  payrollIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AllocateRecordOccupantPayrollsMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly allocateOccupantPayrolls?: Void | null } | null } | null } | null } | null } | null } | null };

export type RemoveRecordOccupantMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
}>;


export type RemoveRecordOccupantMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly removeOccupant?: Void | null } | null } | null } | null } | null } | null } | null };

export type RecordOccupantsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordId: Scalars['ID']['input'];
}>;


export type RecordOccupantsQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly occupants?: ReadonlyArray<{ readonly id: string, readonly employee: { readonly code: string, readonly description?: string | null, readonly id: string, readonly jobTitleId?: string | null, readonly name: string, readonly organization: { readonly entityId: string, readonly recordId: string } }, readonly payrolls: ReadonlyArray<{ readonly payrollIds: ReadonlyArray<string>, readonly assignment: OccupantPayrollAssignment, readonly percent: number, readonly project?: { readonly code: string, readonly name: string } | null, readonly organization: { readonly name: string }, readonly idcAllocations: ReadonlyArray<{ readonly percent: number, readonly idcCategorization: { readonly category: { readonly code: string }, readonly subcategory?: { readonly code: string } | null } }> }> } | null> | null } | null } | null } | null } | null } | null } | null };

export type FragmentSpacePersonFragment = { readonly id: string, readonly code: string, readonly description?: string | null, readonly firstName: string, readonly lastName: string, readonly name: string };

export type SpacePersonsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
}>;


export type SpacePersonsQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spacePersons?: ReadonlyArray<{ readonly id: string, readonly code: string, readonly description?: string | null, readonly firstName: string, readonly lastName: string, readonly name: string }> | null } | null } | null } | null } | null } | null } | null };

export type FragmentOrganizationAssignmentFragment = { readonly id?: string | null, readonly isOccupier?: boolean | null, readonly organizationLookup?: any | null };

export type SpaceRecordAssignOrganizationMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordId: Scalars['ID']['input'];
  input: OrganizationAssignmentInput;
}>;


export type SpaceRecordAssignOrganizationMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spaceRecordAssignOrganization?: Void | null } | null } | null } | null } | null } | null } | null };

export type SpaceRecordRemoveOrganizationAssignmentMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  assignmentId: Scalars['ID']['input'];
}>;


export type SpaceRecordRemoveOrganizationAssignmentMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spaceRecordRemoveOrganizationAssignment?: Void | null } | null } | null } | null } | null } | null } | null };

export type OrganizationAssignmentQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordId: Scalars['ID']['input'];
}>;


export type OrganizationAssignmentQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly organizationAssignment?: { readonly id?: string | null, readonly isOccupier?: boolean | null, readonly organizationLookup?: any | null } | null } | null } | null } | null } | null } | null } | null };

export type FragmentLabAssignmentFragment = { readonly id?: string | null, readonly spaceRecordLookup?: any | null, readonly roomTypeId: string };

export type AddLabsToLabServiceMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  labServiceId: Scalars['ID']['input'];
  labIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddLabsToLabServiceMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly addLabsToLabService?: Void | null } | null } | null } | null } | null } | null } | null };

export type SpaceRecordRemoveLabAssignmentMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  assignmentId: Scalars['ID']['input'];
}>;


export type SpaceRecordRemoveLabAssignmentMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spaceRecordRemoveLabAssignment?: Void | null } | null } | null } | null } | null } | null } | null };

export type CalculatedSpaceRecordFunctionalizationsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CalculatedSpaceRecordFunctionalizationsQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly calculatedSpaceRecordFunctionalizations?: ReadonlyArray<{ readonly functionId: string, readonly percent: number } | null> | null } | null } | null } | null } | null } | null } | null };

export type LabAssignmentsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordId: Scalars['ID']['input'];
}>;


export type LabAssignmentsQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly labAssignments?: ReadonlyArray<{ readonly id?: string | null, readonly spaceRecordLookup?: any | null, readonly roomTypeId: string } | null> | null } | null } | null } | null } | null } | null } | null };

export type FragmentSpaceRecordHistoryLogFragment = { readonly userId: string, readonly action: SpaceRecordHistoryAction, readonly timestamp: any };

export type FragmentSpaceRecordFragment = { readonly id: string, readonly name: string, readonly code: string, readonly description?: string | null, readonly occupierId?: string | null, readonly roomTypeId: string, readonly roomTypeCategory: RoomTypeCategory, readonly sqft: number, readonly anomalies?: ReadonlyArray<Anomaly | null> | null, readonly clusterId?: string | null, readonly comment?: string | null, readonly surveyStatus: SurveyStatus, readonly surveyStatusLite: SurveyStatus, readonly ancestors?: any | null, readonly entityId: string, readonly history?: ReadonlyArray<{ readonly userId: string, readonly action: SpaceRecordHistoryAction, readonly timestamp: any } | null> | null, readonly lastUpdated?: { readonly userId: string, readonly action: SpaceRecordHistoryAction, readonly timestamp: any } | null };

export type BulkUpdateResponsiblePersonsMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
  employeeIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
  primaryResponsiblePersonId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type BulkUpdateResponsiblePersonsMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly bulkUpdateResponsiblePersons?: Void | null } | null } | null } | null } | null } | null } | null };

export type BulkUpdateSpaceRecordsMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
  update: SpaceRecordUpdate;
}>;


export type BulkUpdateSpaceRecordsMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly bulkUpdateSpaceRecords?: ReadonlyArray<string> | null } | null } | null } | null } | null } | null } | null };

export type UpdateSpaceRecordMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordId: Scalars['ID']['input'];
  update: SpaceRecordUpdate;
}>;


export type UpdateSpaceRecordMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly updateSpaceRecord?: { readonly id: string, readonly name: string, readonly code: string, readonly description?: string | null, readonly occupierId?: string | null, readonly roomTypeId: string, readonly roomTypeCategory: RoomTypeCategory, readonly sqft: number, readonly anomalies?: ReadonlyArray<Anomaly | null> | null, readonly clusterId?: string | null, readonly comment?: string | null, readonly surveyStatus: SurveyStatus, readonly surveyStatusLite: SurveyStatus, readonly ancestors?: any | null, readonly entityId: string, readonly history?: ReadonlyArray<{ readonly userId: string, readonly action: SpaceRecordHistoryAction, readonly timestamp: any } | null> | null, readonly lastUpdated?: { readonly userId: string, readonly action: SpaceRecordHistoryAction, readonly timestamp: any } | null } | null } | null } | null } | null } | null } | null } | null };

export type SpaceRecordCountQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  filter?: InputMaybe<SpaceRecordsFilterInput>;
}>;


export type SpaceRecordCountQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spaceRecordsCount?: number | null } | null } | null } | null } | null } | null } | null };

export type SpaceRecordQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordId: Scalars['ID']['input'];
}>;


export type SpaceRecordQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spaceRecord?: { readonly id: string, readonly name: string, readonly code: string, readonly description?: string | null, readonly occupierId?: string | null, readonly roomTypeId: string, readonly roomTypeCategory: RoomTypeCategory, readonly sqft: number, readonly anomalies?: ReadonlyArray<Anomaly | null> | null, readonly clusterId?: string | null, readonly comment?: string | null, readonly surveyStatus: SurveyStatus, readonly surveyStatusLite: SurveyStatus, readonly ancestors?: any | null, readonly entityId: string, readonly history?: ReadonlyArray<{ readonly userId: string, readonly action: SpaceRecordHistoryAction, readonly timestamp: any } | null> | null, readonly lastUpdated?: { readonly userId: string, readonly action: SpaceRecordHistoryAction, readonly timestamp: any } | null } | null } | null } | null } | null } | null } | null } | null };

export type SpaceRecordsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  filter?: InputMaybe<SpaceRecordsFilterInput>;
  pagination?: InputMaybe<SpaceRecordsPaginationInput>;
  sort?: InputMaybe<SpaceRecordsSortInput>;
}>;


export type SpaceRecordsQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spaceRecords?: ReadonlyArray<{ readonly id: string, readonly name: string, readonly code: string, readonly description?: string | null, readonly occupierId?: string | null, readonly roomTypeId: string, readonly roomTypeCategory: RoomTypeCategory, readonly sqft: number, readonly anomalies?: ReadonlyArray<Anomaly | null> | null, readonly clusterId?: string | null, readonly comment?: string | null, readonly surveyStatus: SurveyStatus, readonly surveyStatusLite: SurveyStatus, readonly ancestors?: any | null, readonly entityId: string, readonly history?: ReadonlyArray<{ readonly userId: string, readonly action: SpaceRecordHistoryAction, readonly timestamp: any } | null> | null, readonly lastUpdated?: { readonly userId: string, readonly action: SpaceRecordHistoryAction, readonly timestamp: any } | null } | null> | null } | null } | null } | null } | null } | null } | null };

export type FragmentSpaceRecordFunctionalUsageFragment = { readonly functionalizationMethodology: SpaceRecordFunctionalMethodology, readonly serviceCenterId?: string | null, readonly functionalizations: ReadonlyArray<{ readonly functionId: string, readonly percent: number }> };

export type BulkUpdateSpaceRecordFunctionalUsageMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
  update: SpaceRecordFunctionalUsageUpdate;
}>;


export type BulkUpdateSpaceRecordFunctionalUsageMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly bulkUpdateSpaceRecordFunctionalUsage?: Void | null } | null } | null } | null } | null } | null } | null };

export type UpdateSpaceRecordFunctionalUsageMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordId: Scalars['ID']['input'];
  update: SpaceRecordFunctionalUsageUpdate;
}>;


export type UpdateSpaceRecordFunctionalUsageMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly updateSpaceRecordFunctionalUsage?: { readonly functionalizationMethodology: SpaceRecordFunctionalMethodology, readonly serviceCenterId?: string | null, readonly functionalizations: ReadonlyArray<{ readonly functionId: string, readonly percent: number }> } | null } | null } | null } | null } | null } | null } | null };

export type SpaceRecordFunctionalUsageQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordId: Scalars['ID']['input'];
}>;


export type SpaceRecordFunctionalUsageQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spaceRecordFunctionalUsage?: { readonly functionalizationMethodology: SpaceRecordFunctionalMethodology, readonly serviceCenterId?: string | null, readonly functionalizations: ReadonlyArray<{ readonly functionId: string, readonly percent: number }> } | null } | null } | null } | null } | null } | null } | null };

export type SpaceRecordSignOffMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SpaceRecordSignOffMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spaceRecordSignOff?: ReadonlyArray<string> | null } | null } | null } | null } | null } | null } | null };

export type SpaceRecordUnlockMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SpaceRecordUnlockMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spaceRecordUnlock?: ReadonlyArray<string> | null } | null } | null } | null } | null } | null } | null };

export type SpaceRecordWarningsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordId: Scalars['ID']['input'];
}>;


export type SpaceRecordWarningsQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spaceRecordWarnings?: ReadonlyArray<{ readonly code: SpaceWarningCode, readonly message: string }> | null } | null } | null } | null } | null } | null } | null };

export type AddClusterResponsiblePersonsMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  clusterId: Scalars['ID']['input'];
  employeeIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
  primaryResponsiblePersonId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AddClusterResponsiblePersonsMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly addClusterResponsiblePersons?: Void | null } | null } | null } | null } | null } | null } | null };

export type RemoveClusterResponsiblePersonMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  clusterId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
}>;


export type RemoveClusterResponsiblePersonMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly removeClusterResponsiblePerson?: Void | null } | null } | null } | null } | null } | null } | null };

export type UpdateClusterResponsiblePersonMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  clusterId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
  input: SpaceResponsiblePersonInput;
}>;


export type UpdateClusterResponsiblePersonMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly updateClusterResponsiblePerson?: Void | null } | null } | null } | null } | null } | null } | null };

export type ClusterResponsiblePersonsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  clusterId: Scalars['ID']['input'];
}>;


export type ClusterResponsiblePersonsQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly clusterResponsiblePersons?: ReadonlyArray<{ readonly id: string, readonly isPrimary: boolean, readonly employee: { readonly code: string, readonly description?: string | null, readonly id: string, readonly jobTitleId?: string | null, readonly name: string, readonly organization: { readonly entityId: string, readonly recordId: string } } } | null> | null } | null } | null } | null } | null } | null } | null };

export type FragmentResponsiblePersonFragment = { readonly id: string, readonly isPrimary: boolean, readonly employee: { readonly code: string, readonly description?: string | null, readonly id: string, readonly jobTitleId?: string | null, readonly name: string, readonly organization: { readonly entityId: string, readonly recordId: string } } };

export type AddRecordResponsiblePersonsMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordId: Scalars['ID']['input'];
  employeeIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
  primaryResponsiblePersonId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AddRecordResponsiblePersonsMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly addResponsiblePersons?: Void | null } | null } | null } | null } | null } | null } | null };

export type RemoveRecordResponsiblePersonMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
}>;


export type RemoveRecordResponsiblePersonMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly removeResponsiblePerson?: Void | null } | null } | null } | null } | null } | null } | null };

export type UpdateRecordResponsiblePersonMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
  input: SpaceResponsiblePersonInput;
}>;


export type UpdateRecordResponsiblePersonMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly updateResponsiblePerson?: Void | null } | null } | null } | null } | null } | null } | null };

export type ResponsiblePersonsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordId: Scalars['ID']['input'];
}>;


export type ResponsiblePersonsQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly responsiblePersons?: ReadonlyArray<{ readonly id: string, readonly isPrimary: boolean, readonly employee: { readonly code: string, readonly description?: string | null, readonly id: string, readonly jobTitleId?: string | null, readonly name: string, readonly organization: { readonly entityId: string, readonly recordId: string } } } | null> | null } | null } | null } | null } | null } | null } | null };

export type FragmentServiceCenterFragment = { readonly id: string, readonly name: string, readonly code: string, readonly assignedSpaceIds: ReadonlyArray<string>, readonly functionalizations: ReadonlyArray<{ readonly functionId: string, readonly percent: number } | null> };

export type CreateServiceCenterMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  input: ServiceCenterInput;
}>;


export type CreateServiceCenterMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly createServiceCenter?: { readonly id: string, readonly name: string, readonly code: string, readonly assignedSpaceIds: ReadonlyArray<string>, readonly functionalizations: ReadonlyArray<{ readonly functionId: string, readonly percent: number } | null> } | null } | null } | null } | null } | null } | null } | null };

export type DeleteServiceCenterMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type DeleteServiceCenterMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly deleteServiceCenter?: Void | null } | null } | null } | null } | null } | null } | null };

export type UpdateServiceCenterMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: ServiceCenterInput;
}>;


export type UpdateServiceCenterMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly updateServiceCenter?: { readonly id: string, readonly name: string, readonly code: string, readonly assignedSpaceIds: ReadonlyArray<string>, readonly functionalizations: ReadonlyArray<{ readonly functionId: string, readonly percent: number } | null> } | null } | null } | null } | null } | null } | null } | null };

export type ServiceCentersQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
}>;


export type ServiceCentersQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly serviceCenters?: ReadonlyArray<{ readonly id: string, readonly name: string, readonly code: string, readonly assignedSpaceIds: ReadonlyArray<string>, readonly functionalizations: ReadonlyArray<{ readonly functionId: string, readonly percent: number } | null> } | null> | null } | null } | null } | null } | null } | null } | null };

export type UpdateSpaceUnassignedSponsoredAccountsCommentMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateSpaceUnassignedSponsoredAccountsCommentMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly updateSpacePayrollUnassignedSponsoredAccountsComment?: Void | null } | null } | null } | null } | null } | null } | null };

export type SpaceUnassignedSponsoredAccountsPayrollsCountQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  filter?: InputMaybe<SpacePayrollsFilterInput>;
}>;


export type SpaceUnassignedSponsoredAccountsPayrollsCountQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spaceUnassignedSponsoredPayrollsCount?: number | null } | null } | null } | null } | null } | null } | null };

export type SpaceUnassignedSponsoredAccountsPayrollsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  filter?: InputMaybe<SpacePayrollsFilterInput>;
  pagination?: InputMaybe<SpacePayrollsPaginationInput>;
  sort?: InputMaybe<SpacePayrollsSortInput>;
}>;


export type SpaceUnassignedSponsoredAccountsPayrollsQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spaceUnassignedSponsoredPayrolls?: ReadonlyArray<{ readonly id: string, readonly organization?: any | null, readonly unassignedSponsoredAccountsComment?: string | null, readonly project?: { readonly code: string, readonly name: string } | null }> | null } | null } | null } | null } | null } | null } | null };

export type UpdateSpaceUnassignedSponsoredPeopleCommentMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateSpaceUnassignedSponsoredPeopleCommentMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly updateSpacePayrollUnassignedSponsoredPeopleComment?: Void | null } | null } | null } | null } | null } | null } | null };

export type SpaceUnassignedSponsoredPeoplePayrollsCountQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  filter?: InputMaybe<SpacePayrollsFilterInput>;
}>;


export type SpaceUnassignedSponsoredPeoplePayrollsCountQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spaceUnassignedSponsoredPayrollsCount?: number | null } | null } | null } | null } | null } | null } | null };

export type SpaceUnassignedSponsoredPeoplePayrollsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  filter?: InputMaybe<SpacePayrollsFilterInput>;
  pagination?: InputMaybe<SpacePayrollsPaginationInput>;
  sort?: InputMaybe<SpacePayrollsSortInput>;
}>;


export type SpaceUnassignedSponsoredPeoplePayrollsQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spaceUnassignedSponsoredPayrolls?: ReadonlyArray<{ readonly id: string, readonly organization?: any | null, readonly unassignedSponsoredPeopleComment?: string | null, readonly employee?: { readonly jobTitleId?: string | null, readonly name: string } | null }> | null } | null } | null } | null } | null } | null } | null };

export type FragmentSpacePersonLiteFragment = { readonly id: string, readonly code: string, readonly description?: string | null, readonly firstName: string, readonly lastName: string, readonly name: string };

export type SpacePersonsLiteQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
}>;


export type SpacePersonsLiteQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spacePersons?: ReadonlyArray<{ readonly id: string, readonly code: string, readonly description?: string | null, readonly firstName: string, readonly lastName: string, readonly name: string }> | null } | null } | null } | null } | null } | null } | null };

export type UpdateSpaceRecordFunctionalUsageLiteMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordId: Scalars['ID']['input'];
  update: SpaceRecordFunctionalUsageUpdate;
}>;


export type UpdateSpaceRecordFunctionalUsageLiteMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly updateSpaceRecordFunctionalUsage?: { readonly functionalizationMethodology: SpaceRecordFunctionalMethodology } | null } | null } | null } | null } | null } | null } | null };

export type SpaceRecordFunctionalUsageLiteQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordId: Scalars['ID']['input'];
}>;


export type SpaceRecordFunctionalUsageLiteQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spaceRecordFunctionalUsage?: { readonly functionalizationMethodology: SpaceRecordFunctionalMethodology } | null } | null } | null } | null } | null } | null } | null };

export type SpaceRecordSignOffLiteMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  spaceRecordIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SpaceRecordSignOffLiteMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spaceRecordSignOff?: ReadonlyArray<string> | null } | null } | null } | null } | null } | null } | null };

export type FragmentOrganizationFragment = { readonly id: string, readonly code: string, readonly description?: string | null, readonly entityId: string, readonly name: string, readonly parentId?: string | null, readonly jointUseInfo?: { readonly calculationMode: OrgJointUseCalculationMode, readonly manualFunctionalizations?: ReadonlyArray<{ readonly functionId: string, readonly percent: number }> | null } | null };

export type UpdateOrganizationJointUseMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  organizationEntityId: Scalars['ID']['input'];
  update: OrganizationJointUseUpdate;
}>;


export type UpdateOrganizationJointUseMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly updateOrganizationJointUse?: { readonly id: string, readonly code: string, readonly description?: string | null, readonly entityId: string, readonly name: string, readonly parentId?: string | null, readonly jointUseInfo?: { readonly calculationMode: OrgJointUseCalculationMode, readonly manualFunctionalizations?: ReadonlyArray<{ readonly functionId: string, readonly percent: number }> | null } | null } | null } | null } | null } | null } | null } | null } | null };

export type CalculatedOrgJointUseFunctionalizationsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  calculationMode: OrgJointUseCalculationMode;
}>;


export type CalculatedOrgJointUseFunctionalizationsQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly calculatedOrgJointUseFunctionalizations?: ReadonlyArray<{ readonly functionId: string, readonly percent: number } | null> | null } | null } | null } | null } | null } | null } | null };

export type OrganizationsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  filter?: InputMaybe<OrganizationsFilterInput>;
}>;


export type OrganizationsQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly organizations?: ReadonlyArray<{ readonly id: string, readonly code: string, readonly description?: string | null, readonly entityId: string, readonly name: string, readonly parentId?: string | null, readonly jointUseInfo?: { readonly calculationMode: OrgJointUseCalculationMode, readonly manualFunctionalizations?: ReadonlyArray<{ readonly functionId: string, readonly percent: number }> | null } | null } | null> | null } | null } | null } | null } | null } | null } | null };

export type SpaceReportIdsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
}>;


export type SpaceReportIdsQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly spaceReportIds?: ReadonlyArray<SpaceReportId> | null } | null } | null } | null } | null } | null } | null };

export type GenerateSpaceReportFileMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  reportId: SpaceReportId;
  configuration: SpaceReportConfigurationInput;
}>;


export type GenerateSpaceReportFileMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly generateSpaceReportFile?: Void | null } | null } | null } | null } | null } | null } | null };

export type RoomTypesQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
}>;


export type RoomTypesQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly roomTypes?: ReadonlyArray<{ readonly id: string, readonly code: string, readonly name: string, readonly description?: string | null, readonly category: RoomTypeCategory } | null> | null } | null } | null } | null } | null } | null } | null };

export type UpsertSurveyConfigurationMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  input: SpaceSurveyConfigurationInput;
}>;


export type UpsertSurveyConfigurationMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly upsertSurveyConfiguration?: Void | null } | null } | null } | null } | null } | null } | null };

export type GetSpaceSurveyConfigurationQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
}>;


export type GetSpaceSurveyConfigurationQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly surveyConfiguration?: { readonly code: string, readonly id: string, readonly name: string, readonly functionalUsage?: { readonly requireFunctionalUsageAssignmentsForSelectedAccounts: boolean, readonly requireSponsoredAccountAssignmentsForSponsoredFunctionalUsages: boolean } | null, readonly tools: { readonly allowUsersToUnlockRoomsDirectly: boolean } } | null } | null } | null } | null } | null } | null } | null };

export type FragmentSpaceUserAccessFragment = { readonly id: string, readonly userId: string, readonly name: string, readonly code: string, readonly organization?: any | null };

export type FragmentSpaceUserAccessUserFragment = { readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null };

export type AssignStandardUserMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  organizationIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AssignStandardUserMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly assignStandardUser?: Void | null } | null } | null } | null } | null } | null } | null };

export type AssignSurveyAdminMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type AssignSurveyAdminMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly assignSurveyAdmin?: Void | null } | null } | null } | null } | null } | null } | null };

export type RemoveAccessAssignmentMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type RemoveAccessAssignmentMutation = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly removeAccessAssignment?: Void | null } | null } | null } | null } | null } | null } | null };

export type StandardUsersQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
}>;


export type StandardUsersQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly standardUsers?: ReadonlyArray<{ readonly id: string, readonly userId: string, readonly name: string, readonly code: string, readonly organization?: any | null } | null> | null } | null } | null } | null } | null } | null } | null };

export type SurveyAdminsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
}>;


export type SurveyAdminsQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly scenario?: { readonly extra?: { readonly space?: { readonly surveyAdmins?: ReadonlyArray<{ readonly id: string, readonly userId: string, readonly name: string, readonly code: string, readonly organization?: any | null } | null> | null } | null } | null } | null } | null } | null } | null };

export type SpaceAssignableUsersQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SpaceAssignableUsersQuery = { readonly tenant?: { readonly zone?: { readonly app?: { readonly users?: { readonly items: ReadonlyArray<{ readonly info?: { readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null } | null> } | null } | null } | null } | null };

export type QueryAssignmentsDataQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  query: Scalars['AWSJSON']['input'];
}>;


export type QueryAssignmentsDataQuery = { readonly tenant?: { readonly zone?: { readonly data?: any | null } | null } | null };

export type QueryOutcomesDataQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  query: Scalars['AWSJSON']['input'];
}>;


export type QueryOutcomesDataQuery = { readonly tenant?: { readonly zone?: { readonly data?: any | null } | null } | null };

export type QueryUnitsDataQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  query: Scalars['AWSJSON']['input'];
}>;


export type QueryUnitsDataQuery = { readonly tenant?: { readonly zone?: { readonly data?: any | null } | null } | null };

export type GuideArchiveMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  archive: Archive;
}>;


export type GuideArchiveMutation = { readonly tenant?: { readonly zone?: { readonly guideArchive?: string | null } | null } | null };

export type SummarizeArchiveMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  archive: Archive;
}>;


export type SummarizeArchiveMutation = { readonly tenant?: { readonly zone?: { readonly summarizeArchive?: string | null } | null } | null };

export type FragmentCheckInResponseFragment = { readonly mood?: string | null, readonly prompt?: string | null, readonly response?: string | null, readonly from?: { readonly id?: string | null, readonly name?: string | null } | null, readonly submittedOn?: { readonly date?: any | null, readonly utcOffset?: number | null } | null };

export type FragmentCheckInFragment = { readonly title?: string | null, readonly prompt?: string | null, readonly suggestedResponses?: ReadonlyArray<string | null> | null };

export type SubmitCheckInResponseMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  prompt?: InputMaybe<Scalars['String']['input']>;
  response: Scalars['String']['input'];
  mood?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubmitCheckInResponseMutation = { readonly tenant?: { readonly zone?: { readonly submitCheckInResponse?: string | null } | null } | null };

export type CheckInResponsesQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  from?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  submittedBefore?: InputMaybe<Scalars['AWSDate']['input']>;
  submittedAfter?: InputMaybe<Scalars['AWSDate']['input']>;
  submittedNotBefore?: InputMaybe<Scalars['AWSDate']['input']>;
  submittedNotAfter?: InputMaybe<Scalars['AWSDate']['input']>;
}>;


export type CheckInResponsesQuery = { readonly tenant?: { readonly zone?: { readonly checkInResponses?: ReadonlyArray<{ readonly mood?: string | null, readonly prompt?: string | null, readonly response?: string | null, readonly from?: { readonly id?: string | null, readonly name?: string | null } | null, readonly submittedOn?: { readonly date?: any | null, readonly utcOffset?: number | null } | null } | null> | null } | null } | null };

export type CheckInQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  mood?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckInQuery = { readonly tenant?: { readonly zone?: { readonly checkIn?: { readonly title?: string | null, readonly prompt?: string | null, readonly suggestedResponses?: ReadonlyArray<string | null> | null } | null } | null } | null };

export type EligibleForDailyCheckInQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
}>;


export type EligibleForDailyCheckInQuery = { readonly tenant?: { readonly zone?: { readonly eligibleForDailyCheckIn?: boolean | null } | null } | null };

export type FragmentSummitPulseEngagementBreakdownFragment = { readonly thriving?: number | null, readonly engaged?: number | null, readonly atRisk?: number | null, readonly disengaged?: number | null, readonly summary?: string | null };

export type FragmentSummitPulseFragment = { readonly teamSpirit?: { readonly description?: string | null, readonly overallMood?: string | null } | null, readonly teamMembersOverview?: ReadonlyArray<{ readonly name?: string | null, readonly highlight?: string | null, readonly concern?: string | null } | null> | null, readonly engagementBreakdown?: { readonly thriving?: number | null, readonly engaged?: number | null, readonly atRisk?: number | null, readonly disengaged?: number | null, readonly summary?: string | null } | null };

export type FragmentSummitPulseTeamMemberOverviewFragment = { readonly name?: string | null, readonly highlight?: string | null, readonly concern?: string | null };

export type FragmentSummitPulseTeamSpiritFragment = { readonly description?: string | null, readonly overallMood?: string | null };

export type SummitPulseQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
  fromDate?: InputMaybe<Scalars['AWSDate']['input']>;
}>;


export type SummitPulseQuery = { readonly tenant?: { readonly zone?: { readonly pulse?: { readonly teamSpirit?: { readonly description?: string | null, readonly overallMood?: string | null } | null, readonly teamMembersOverview?: ReadonlyArray<{ readonly name?: string | null, readonly highlight?: string | null, readonly concern?: string | null } | null> | null, readonly engagementBreakdown?: { readonly thriving?: number | null, readonly engaged?: number | null, readonly atRisk?: number | null, readonly disengaged?: number | null, readonly summary?: string | null } | null } | null } | null } | null };
